import React, { useState, useRef } from 'react';
import { ChevronLeft, ChevronRight, Volume2, VolumeX, Loader2, BookOpen, Heart, Utensils, Moon, Droplets, Baby, Shield, Users, Milk, AlertTriangle, Snowflake, Thermometer, Music } from 'lucide-react';
import axios from 'axios';
import BiberonCarousel from './BiberonCarousel';
import ChangeCarousel from './ChangeCarousel';
import BainCarousel from './BainCarousel';
import CordonCarousel from './CordonCarousel';
import ChangeDeboutCarousel from './ChangeDeboutCarousel';
import LavageMainsCarousel from './LavageMainsCarousel';
import QuizComponent from './QuizComponent';

const BACKEND_URL = window.location.origin;

// Images URLs
const IMAGES = {
  virginiaHenderson: "https://static.prod-images.emergentagent.com/jobs/ce700867-d63b-4643-9c59-56aff33c469f/images/f5332773a2cd9330af04d3c7da1a1e0f53b60407907ddeb89a1113a873d96ea7.png",
  henderson14Needs: "https://static.prod-images.emergentagent.com/jobs/ce700867-d63b-4643-9c59-56aff33c469f/images/ea2c645a0b8a5032a6992e96f92e5bf7c90c861b8e3ba9325bfc71395ab1d930.png",
  maslowPyramid: "https://static.prod-images.emergentagent.com/jobs/ce700867-d63b-4643-9c59-56aff33c469f/images/c6d4c57dfb74541a2d8cdddd918424cb75192af2c240e17d1d2d43a0bb299d42.png",
  babyFeeding: "https://images.unsplash.com/flagged/photo-1570560558077-45ad028193e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxtb3RoZXIlMjBmZWVkaW5nJTIwYmFieSUyMGJvdHRsZSUyMG1pbGslMjBoYXBweXxlbnwwfHx8fDE3NzE2ODc1OTV8MA&ixlib=rb-4.1.0&q=85",
  babyBottle: "https://static.prod-images.emergentagent.com/jobs/0bdb7109-8029-4d81-a486-71beb721288a/images/5f6ab066d1bf6876b7dbf2c78784357f2fe6520af378075b8330911ebc355765.png",
  babyBottleFormula: "https://images.pexels.com/photos/11501481/pexels-photo-11501481.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  babySleeping: "https://images.unsplash.com/photo-1770059706518-ece8f7264055?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxiYWJ5JTIwc2xlZXBpbmclMjBwZWFjZWZ1bCUyMGNyaWJ8ZW58MHx8fHwxNzcxNjgzOTU0fDA&ixlib=rb-4.1.0&q=85",
  babySleeping2: "https://images.pexels.com/photos/4964215/pexels-photo-4964215.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  motherBaby: "https://images.pexels.com/photos/19773995/pexels-photo-19773995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  toddlerEating: "https://images.unsplash.com/photo-1557939663-0619f304af9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHx0b2RkbGVyJTIwZWF0aW5nJTIwYXV0b25vbXl8ZW58MHx8fHwxNzcxNjgzOTU2fDA&ixlib=rb-4.1.0&q=85",
  babyEating: "https://images.pexels.com/photos/4881007/pexels-photo-4881007.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  babyHygiene: "https://static.prod-images.emergentagent.com/jobs/d360307e-e9a5-4cf6-9001-bfad74aa89d8/images/aaf97c4d65247fe8ba3ef4ce5f9f197169542ddbdd88874e15bb6063ec0879fc.png",
  motherBonding: "https://images.pexels.com/photos/67663/baby-baby-with-mom-mother-kiss-tenderness-67663.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  toddlerPlay: "https://images.pexels.com/photos/5215553/pexels-photo-5215553.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  breastfeeding1: "https://static.prod-images.emergentagent.com/jobs/2096e805-0d2d-4bfa-ad0e-f8c9e730a1c5/images/545403f780449d69dfea344ae59481d58b8b05e3664bdfa7bb82d1bea24c1caa.png",
  breastfeeding2: "https://static.prod-images.emergentagent.com/jobs/2096e805-0d2d-4bfa-ad0e-f8c9e730a1c5/images/840870d165fdd0f33c17d5007fae7964122e7fc34f08e7a0582458d07c26564f.png",
  breastfeeding3: "https://static.prod-images.emergentagent.com/jobs/2096e805-0d2d-4bfa-ad0e-f8c9e730a1c5/images/30ca5f0e5709d7cd9f85e11153f2ad99b8f272b56f76c9b725e5e715c884855e.png",
  milkStorage: "https://images.unsplash.com/photo-1576186726183-9bd8aa9fa6d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxicmVhc3QlMjBtaWxrJTIwc3RvcmFnZSUyMHJlZnJpZ2VyYXRvciUyMGJvdHRsZXxlbnwwfHx8fDE3NzE2ODY5ODJ8MA&ixlib=rb-4.1.0&q=85",
  lavageMains: "https://static.prod-images.emergentagent.com/jobs/5d22348a-efc5-4943-a2b2-c44a5e71b6ae/images/80ec56c38a0dd2db93cfbb2afcd2946bf4b3813e8ce21793563e5c6928f6c53c.png"
};

// Questions de quiz pour les différentes sections
const QUIZ_ALIMENTATION = [
  {
    question: "À quelle température doit être préparé un biberon de lait ?",
    answers: ["25°C", "30°C", "37°C", "40°C"],
    correctAnswer: 2,
    explanation: "Le biberon doit être à température corporelle, soit environ 37°C, pour être agréable et sécuritaire pour le bébé."
  },
  {
    question: "Combien de temps maximum peut-on conserver un biberon préparé à température ambiante ?",
    answers: ["30 minutes", "1 heure", "2 heures", "4 heures"],
    correctAnswer: 1,
    explanation: "Un biberon préparé ne doit pas être conservé plus d'1 heure à température ambiante pour éviter la prolifération bactérienne."
  },
  {
    question: "Quelle est la durée de conservation du lait maternel au réfrigérateur ?",
    answers: ["24 heures", "48 heures", "5 jours", "1 semaine"],
    correctAnswer: 1,
    explanation: "Le lait maternel se conserve 48 heures au réfrigérateur (entre 0 et 4°C)."
  },
  {
    question: "Quelle position est recommandée pour donner le biberon ?",
    answers: ["Bébé couché à plat", "Bébé semi-assis, tête légèrement surélevée", "Bébé debout", "Peu importe la position"],
    correctAnswer: 1,
    explanation: "Le bébé doit être en position semi-assise avec la tête légèrement surélevée pour éviter les fausses routes et favoriser la digestion."
  },
  {
    question: "À partir de quel âge commence la diversification alimentaire ?",
    answers: ["3 mois", "4-6 mois", "8 mois", "12 mois"],
    correctAnswer: 1,
    explanation: "La diversification alimentaire débute généralement entre 4 et 6 mois, selon les recommandations de l'OMS et du pédiatre."
  }
];

const QUIZ_SOMMEIL = [
  {
    question: "Quelle est la position de couchage recommandée pour un nourrisson ?",
    answers: ["Sur le ventre", "Sur le côté", "Sur le dos", "Peu importe"],
    correctAnswer: 2,
    explanation: "La position sur le dos est recommandée pour prévenir la mort inattendue du nourrisson (MIN). C'est la position la plus sûre."
  },
  {
    question: "Quelle est la température idéale d'une chambre d'enfant ?",
    answers: ["16-17°C", "18-20°C", "22-24°C", "25-27°C"],
    correctAnswer: 1,
    explanation: "La température idéale est entre 18 et 20°C. Une chambre trop chaude augmente les risques de MIN."
  },
  {
    question: "Pourquoi les rituels du coucher sont-ils importants ?",
    answers: ["Pour gagner du temps", "Pour sécuriser l'enfant et faciliter l'endormissement", "Pour fatiguer l'enfant", "Pour le faire manger avant de dormir"],
    correctAnswer: 1,
    explanation: "Les rituels créent un cadre sécurisant et prévisible qui aide l'enfant à se préparer au sommeil sereinement."
  },
  {
    question: "Combien d'heures dort en moyenne un nourrisson de 0 à 3 mois ?",
    answers: ["8-10 heures", "12-14 heures", "16-18 heures", "20-22 heures"],
    correctAnswer: 2,
    explanation: "Un nourrisson de 0 à 3 mois dort en moyenne 16 à 18 heures par jour, réparties en plusieurs cycles."
  },
  {
    question: "Que doit-on éviter dans le lit d'un bébé ?",
    answers: ["Un drap-housse", "Une gigoteuse adaptée", "Couette, oreiller, tour de lit", "Un matelas ferme"],
    correctAnswer: 2,
    explanation: "Couettes, oreillers et tours de lit sont à proscrire car ils présentent des risques d'étouffement et de surchauffe."
  }
];

const QUIZ_CHANGE_COUCHER = [
  {
    question: "Quelle est la première étape avant de commencer un change ?",
    answers: ["Déshabiller l'enfant", "Se laver les mains", "Préparer la couche propre", "Allonger l'enfant"],
    correctAnswer: 1,
    explanation: "Le lavage des mains est toujours la première étape pour garantir l'hygiène et prévenir les infections."
  },
  {
    question: "Pourquoi ne doit-on jamais quitter l'enfant des yeux pendant le change ?",
    answers: ["Pour lui parler", "Pour le distraire", "Pour prévenir les chutes", "Pour observer ses réactions"],
    correctAnswer: 2,
    explanation: "Le risque de chute de la table à langer est élevé. L'enfant ne doit jamais être laissé sans surveillance."
  },
  {
    question: "Comment doit-on nettoyer les parties génitales d'une fille ?",
    answers: ["De l'arrière vers l'avant", "De l'avant vers l'arrière", "En mouvements circulaires", "De gauche à droite"],
    correctAnswer: 1,
    explanation: "Toujours de l'avant vers l'arrière pour éviter de ramener les germes fécaux vers la vulve et prévenir les infections urinaires."
  },
  {
    question: "Que faut-il vérifier à chaque change ?",
    answers: ["Le poids de l'enfant", "L'état de la peau (rougeurs, irritations)", "La température de la pièce", "L'heure du prochain repas"],
    correctAnswer: [1, 2],
    explanation: "L'observation de la peau permet de détecter érythèmes fessiers, irritations ou autres anomalies. La température de la pièce doit aussi être vérifiée pour le confort de l'enfant (idéalement 22-24°C)."
  },
  {
    question: "Où doit-on jeter la couche sale ?",
    answers: ["Dans la poubelle ordinaire", "Dans une poubelle à couvercle fermé", "Dans les toilettes", "Dans un sac plastique ouvert"],
    correctAnswer: 1,
    explanation: "Une poubelle à couvercle fermé limite les odeurs et la prolifération bactérienne."
  }
];

const QUIZ_CHANGE_DEBOUT = [
  {
    question: "À partir de quel âge peut-on généralement proposer le change debout ?",
    answers: ["6 à 12 mois", "18 à 24 mois", "3 ans et plus", "Dès la naissance"],
    correctAnswer: 1,
    explanation: "Le change debout se propose généralement entre 18 et 24 mois, quand l'enfant tient debout de manière stable et manifeste un intérêt pour l'autonomie."
  },
  {
    question: "Quel est l'objectif principal du change debout ?",
    answers: ["Gagner du temps", "Favoriser l'autonomie et la participation de l'enfant", "Éviter les chutes", "Réduire l'utilisation de lingettes"],
    correctAnswer: 1,
    explanation: "Le change debout vise à favoriser l'autonomie et la participation active de l'enfant, contribuant au développement de son estime de soi."
  },
  {
    question: "Quelle théoricienne a identifié 14 besoins fondamentaux dont 'être propre' ?",
    answers: ["Maria Montessori", "Virginia Henderson", "Françoise Dolto", "Jean Piaget"],
    correctAnswer: 1,
    explanation: "Virginia Henderson a identifié 14 besoins fondamentaux, dont le besoin 'd'être propre et protéger ses téguments'."
  },
  {
    question: "Dans quel sens doit-on nettoyer lors du change ?",
    answers: ["De l'arrière vers l'avant", "De l'avant vers l'arrière", "En mouvements circulaires", "Peu importe le sens"],
    correctAnswer: 1,
    explanation: "On nettoie toujours de l'avant vers l'arrière pour éviter la contamination par les germes fécaux, particulièrement important chez les filles."
  },
  {
    question: "Quelle est la dernière étape du change debout ?",
    answers: ["Mettre la couche propre", "Valoriser l'enfant", "Le lavage des mains ensemble", "Jeter la couche sale"],
    correctAnswer: 2,
    explanation: "Le lavage des mains est la dernière étape essentielle du change. C'est un moment d'apprentissage de l'hygiène pour l'enfant."
  }
];

const QUIZ_LAVAGE_MAINS = [
  {
    question: "Combien de temps minimum doit durer le savonnage des mains ?",
    answers: ["10 secondes", "20 secondes", "30 secondes", "1 minute"],
    correctAnswer: 2,
    explanation: "Le savonnage doit durer au minimum 30 secondes pour être efficace. C'est pourquoi on utilise des comptines de cette durée avec les enfants."
  },
  {
    question: "Quelles zones sont souvent oubliées lors du lavage des mains ?",
    answers: ["Les paumes", "Les pouces et entre les doigts", "Le dos des mains", "Le poignet"],
    correctAnswer: 1,
    explanation: "Les pouces et les espaces entre les doigts sont les zones les plus souvent oubliées lors du lavage des mains."
  },
  {
    question: "Pourquoi est-il important de bien sécher les mains ?",
    answers: ["Pour le confort", "Pour éviter les gerçures", "Car les mains humides favorisent la prolifération bactérienne", "Pour éviter de glisser"],
    correctAnswer: 2,
    explanation: "Les mains humides sont un terrain propice à la prolifération des bactéries. Un bon séchage est donc essentiel."
  },
  {
    question: "Quand faut-il se laver les mains en EAJE ?",
    answers: ["Uniquement avant les repas", "Avant les repas et après les toilettes seulement", "Avant/après repas, après toilettes, change, mouchage, activité extérieure", "Une fois par heure"],
    correctAnswer: 2,
    explanation: "Le lavage des mains doit être fait avant et après les repas, après les toilettes, après un change, après s'être mouché et après une activité extérieure."
  },
  {
    question: "Quel est le principe fondamental lors de l'accompagnement au lavage des mains ?",
    answers: ["Faire à la place de l'enfant pour aller plus vite", "Faire avec l'enfant et non à sa place", "Laisser l'enfant totalement seul", "Utiliser uniquement du gel hydroalcoolique"],
    correctAnswer: 1,
    explanation: "L'adulte doit 'faire avec' et non 'à la place de' l'enfant pour favoriser son autonomie et sa responsabilisation."
  }
];

const QUIZ_BAIN = [
  {
    question: "Quelle est la température idéale de l'eau du bain ?",
    answers: ["32-34°C", "35-36°C", "37°C", "39-40°C"],
    correctAnswer: 2,
    explanation: "L'eau du bain doit être à 37°C, température corporelle, vérifiée avec un thermomètre de bain."
  },
  {
    question: "Quelle est la première chose à vérifier avant de mettre l'enfant dans le bain ?",
    answers: ["La propreté de la baignoire", "La température de l'eau", "La présence de jouets", "L'heure"],
    correctAnswer: 1,
    explanation: "La température de l'eau doit toujours être vérifiée en premier pour éviter les brûlures ou l'inconfort."
  },
  {
    question: "Comment doit-on tenir le bébé pour le mettre dans le bain ?",
    answers: ["Par les bras", "Par les pieds", "Tête et nuque soutenues, main sous l'aisselle", "Par le ventre"],
    correctAnswer: 2,
    explanation: "La tête et la nuque doivent être soutenues, avec la main passée sous l'aisselle du bébé pour une prise sécurisée."
  },
  {
    question: "Quelle partie du corps lave-t-on en dernier ?",
    answers: ["Les cheveux", "Le visage", "Les pieds", "Le siège"],
    correctAnswer: 3,
    explanation: "Le siège (zone du change) est toujours lavé en dernier pour des raisons d'hygiène."
  },
  {
    question: "Peut-on laisser un enfant seul dans le bain 'juste une seconde' ?",
    answers: ["Oui si l'eau est peu profonde", "Oui si l'enfant sait s'asseoir", "Non, jamais", "Oui avec un siège de bain"],
    correctAnswer: 2,
    explanation: "JAMAIS. Un enfant peut se noyer en quelques secondes dans très peu d'eau. La surveillance doit être constante."
  }
];

const QUIZ_CORDON = [
  {
    question: "Quand tombe généralement le cordon ombilical ?",
    answers: ["3 à 5 jours", "5 à 15 jours", "3 à 4 semaines", "1 mois"],
    correctAnswer: 1,
    explanation: "Le cordon ombilical tombe généralement entre 5 et 15 jours après la naissance."
  },
  {
    question: "Quel produit utilise-t-on pour nettoyer le cordon ?",
    answers: ["Alcool à 70°", "Eau et savon doux ou sérum physiologique", "Bétadine", "Eau oxygénée"],
    correctAnswer: 1,
    explanation: "On utilise de l'eau et du savon doux ou du sérum physiologique. L'alcool n'est plus recommandé car il retarde la cicatrisation."
  },
  {
    question: "Quel signe doit alerter concernant le cordon ?",
    answers: ["Aspect sec", "Rougeur, gonflement, écoulement malodorant", "Couleur jaunâtre", "Léger saignement à la chute"],
    correctAnswer: 1,
    explanation: "Rougeur, gonflement, écoulement purulent ou malodorant sont des signes d'infection nécessitant une consultation médicale urgente."
  },
  {
    question: "Comment positionner la couche par rapport au cordon ?",
    answers: ["Par-dessus le cordon", "Repliée sous le cordon", "Cela n'a pas d'importance", "Couche spéciale nouveau-né avec encoche"],
    correctAnswer: 1,
    explanation: "La couche doit être repliée sous le cordon pour le laisser à l'air et éviter les frottements et l'humidité."
  },
  {
    question: "Combien de fois par jour doit-on nettoyer le cordon ?",
    answers: ["1 fois par semaine", "1 fois par jour", "À chaque change", "Uniquement au bain"],
    correctAnswer: 2,
    explanation: "Le cordon doit être nettoyé à chaque change pour maintenir une bonne hygiène et favoriser la cicatrisation."
  }
];

const QUIZ_AUTONOMIE = [
  {
    question: "Quel est le principe fondamental pour favoriser l'autonomie de l'enfant ?",
    answers: ["Faire à la place de l'enfant", "Laisser l'enfant se débrouiller seul", "Faire avec l'enfant", "Attendre qu'il demande de l'aide"],
    correctAnswer: 2,
    explanation: "Le principe est de 'faire avec' l'enfant, en l'accompagnant et le guidant, pas en faisant à sa place."
  },
  {
    question: "À quel besoin de Maslow correspond le développement de l'autonomie ?",
    answers: ["Besoins physiologiques", "Besoin de sécurité", "Besoin d'estime de soi", "Besoin d'appartenance"],
    correctAnswer: 2,
    explanation: "L'autonomie répond au besoin d'estime de soi dans la pyramide de Maslow, contribuant à la confiance en soi."
  },
  {
    question: "Quelle attitude adopter face aux erreurs de l'enfant qui apprend ?",
    answers: ["Corriger immédiatement", "Punir pour qu'il fasse attention", "Encourager et valoriser les efforts", "Faire à sa place pour éviter l'échec"],
    correctAnswer: 2,
    explanation: "Il faut encourager et valoriser les efforts, même si le résultat n'est pas parfait. L'erreur fait partie de l'apprentissage."
  },
  {
    question: "Que peut faire un enfant 'moyen' (12-24 mois) pour développer son autonomie ?",
    answers: ["S'habiller seul", "Manger seul partiellement, ranger ses jouets", "Aller aux toilettes seul", "Préparer son repas"],
    correctAnswer: 1,
    explanation: "L'enfant moyen peut commencer à manger seul (avec aide), ranger ses jouets avec l'adulte, participer au déshabillage."
  },
  {
    question: "Pourquoi est-il important de laisser l'enfant explorer ?",
    answers: ["Pour qu'il se fatigue", "Pour développer sa motricité et sa confiance", "Pour avoir du temps libre", "Pour qu'il apprenne à obéir"],
    correctAnswer: 1,
    explanation: "L'exploration permet le développement moteur, cognitif et renforce la confiance en soi de l'enfant."
  }
];

const QUIZ_SECURITE_AFFECTIVE = [
  {
    question: "Qu'est-ce que la sécurité affective pour l'enfant ?",
    answers: ["Ne jamais le laisser pleurer", "Un environnement stable et des réponses prévisibles à ses besoins", "Le garder toujours dans les bras", "Satisfaire tous ses désirs"],
    correctAnswer: 1,
    explanation: "La sécurité affective c'est offrir un environnement stable, prévisible, avec des adultes qui répondent de façon cohérente aux besoins de l'enfant."
  },
  {
    question: "Qu'est-ce qu'un objet transitionnel ?",
    answers: ["Un jouet éducatif", "Un objet qui aide l'enfant à gérer la séparation (doudou, tétine)", "Un vêtement de rechange", "Un médicament"],
    correctAnswer: 1,
    explanation: "L'objet transitionnel (doudou, tétine) aide l'enfant à supporter la séparation et à se sentir en sécurité."
  },
  {
    question: "Pourquoi les rituels sont-ils importants pour la sécurité affective ?",
    answers: ["Pour structurer la journée", "Pour faire obéir l'enfant", "Ils créent des repères rassurants et prévisibles", "Pour gagner du temps"],
    correctAnswer: 2,
    explanation: "Les rituels créent des repères prévisibles qui sécurisent l'enfant en lui permettant d'anticiper ce qui va se passer."
  },
  {
    question: "Quelle attitude de l'adulte favorise la sécurité affective ?",
    answers: ["Être imprévisible pour surprendre l'enfant", "Répondre avec constance et cohérence", "Éviter tout contact physique", "Changer souvent les règles"],
    correctAnswer: 1,
    explanation: "La constance et la cohérence dans les réponses de l'adulte permettent à l'enfant de construire sa sécurité intérieure."
  },
  {
    question: "Comment accueillir les émotions de l'enfant ?",
    answers: ["Ignorer les pleurs pour ne pas l'encourager", "Reconnaître et verbaliser ses émotions", "Distraire immédiatement l'enfant", "Lui dire de se calmer"],
    correctAnswer: 1,
    explanation: "Reconnaître et verbaliser les émotions aide l'enfant à les comprendre et à se sentir entendu et compris."
  }
];

const QUIZ_GENERAL = [
  {
    question: "Combien de besoins fondamentaux Virginia Henderson a-t-elle identifiés ?",
    answers: ["10", "12", "14", "16"],
    correctAnswer: 2,
    explanation: "Virginia Henderson a identifié 14 besoins fondamentaux de l'être humain."
  },
  {
    question: "Quelle est la température idéale pour l'eau du bain ET du biberon ?",
    answers: ["35°C", "37°C", "39°C", "40°C"],
    correctAnswer: 1,
    explanation: "37°C est la température corporelle, idéale pour le bain et le biberon."
  },
  {
    question: "Quelle position de couchage est recommandée pour prévenir la MIN ?",
    answers: ["Sur le ventre", "Sur le côté", "Sur le dos", "Position semi-assise"],
    correctAnswer: 2,
    explanation: "Le couchage sur le dos est recommandé pour prévenir la mort inattendue du nourrisson."
  },
  {
    question: "Dans quel sens nettoie-t-on les parties génitales ?",
    answers: ["De l'arrière vers l'avant", "De l'avant vers l'arrière", "En cercles", "Peu importe"],
    correctAnswer: 1,
    explanation: "Toujours de l'avant vers l'arrière pour éviter les infections."
  },
  {
    question: "Combien de temps dure le savonnage des mains ?",
    answers: ["10 secondes", "20 secondes", "30 secondes", "1 minute"],
    correctAnswer: 2,
    explanation: "30 secondes minimum sont nécessaires pour un lavage efficace."
  },
  {
    question: "Quand tombe généralement le cordon ombilical ?",
    answers: ["3-5 jours", "5-15 jours", "3-4 semaines", "1 mois"],
    correctAnswer: 1,
    explanation: "Le cordon tombe généralement entre 5 et 15 jours."
  },
  {
    question: "Quelle est la température idéale d'une chambre d'enfant ?",
    answers: ["16-17°C", "18-20°C", "22-24°C", "25-27°C"],
    correctAnswer: 1,
    explanation: "18-20°C est la température recommandée pour la chambre."
  },
  {
    question: "À partir de quel âge propose-t-on le change debout ?",
    answers: ["6-12 mois", "18-24 mois", "3 ans", "Dès la marche"],
    correctAnswer: 1,
    explanation: "Le change debout se propose vers 18-24 mois quand l'enfant tient bien debout."
  },
  {
    question: "Quel est le principe fondamental de l'accompagnement à l'autonomie ?",
    answers: ["Faire à la place", "Laisser faire seul", "Faire avec", "Montrer une fois"],
    correctAnswer: 2,
    explanation: "'Faire avec' l'enfant et non 'à sa place' est le principe de base."
  },
  {
    question: "Peut-on laisser un enfant seul dans le bain ?",
    answers: ["Oui si l'eau est basse", "Oui avec un siège de bain", "Non, jamais", "Oui quelques secondes"],
    correctAnswer: 2,
    explanation: "JAMAIS. La noyade peut survenir en quelques secondes."
  },
  {
    question: "Qu'est-ce qu'un objet transitionnel ?",
    answers: ["Un jouet éducatif", "Un doudou ou objet réconfortant", "Un vêtement", "Un livre"],
    correctAnswer: 1,
    explanation: "Le doudou est un objet transitionnel qui aide à gérer les séparations."
  },
  {
    question: "Quel produit pour nettoyer le cordon ombilical ?",
    answers: ["Alcool à 70°", "Eau et savon doux", "Bétadine", "Eau oxygénée"],
    correctAnswer: 1,
    explanation: "Eau et savon doux ou sérum physiologique, l'alcool retarde la cicatrisation."
  },
  {
    question: "Combien d'heures dort un nourrisson de 0-3 mois ?",
    answers: ["8-10h", "12-14h", "16-18h", "20-22h"],
    correctAnswer: 2,
    explanation: "Un nourrisson de 0-3 mois dort en moyenne 16-18 heures par jour."
  },
  {
    question: "Quand commence la diversification alimentaire ?",
    answers: ["3 mois", "4-6 mois", "8 mois", "12 mois"],
    correctAnswer: 1,
    explanation: "La diversification débute entre 4 et 6 mois selon les recommandations."
  },
  {
    question: "Quelle zone est souvent oubliée au lavage des mains ?",
    answers: ["Paumes", "Pouces et entre doigts", "Dos des mains", "Poignets"],
    correctAnswer: 1,
    explanation: "Les pouces et espaces interdigitaux sont les plus souvent oubliés."
  },
  {
    question: "Pourquoi bien sécher les mains ?",
    answers: ["Confort", "Éviter gerçures", "Mains humides = bactéries", "Éviter de glisser"],
    correctAnswer: 2,
    explanation: "L'humidité favorise la prolifération bactérienne."
  },
  {
    question: "Que doit-on éviter dans le lit du bébé ?",
    answers: ["Drap-housse", "Gigoteuse", "Couette et oreiller", "Matelas ferme"],
    correctAnswer: 2,
    explanation: "Couettes et oreillers présentent des risques d'étouffement."
  },
  {
    question: "Comment accueillir les émotions de l'enfant ?",
    answers: ["Les ignorer", "Les verbaliser et reconnaître", "Distraire l'enfant", "Lui demander de se calmer"],
    correctAnswer: 1,
    explanation: "Reconnaître et verbaliser les émotions aide l'enfant à les comprendre."
  },
  {
    question: "Quel signe alerte sur le cordon ombilical ?",
    answers: ["Aspect sec", "Rougeur et écoulement malodorant", "Couleur jaunâtre", "Léger saignement"],
    correctAnswer: 1,
    explanation: "Rougeur, gonflement, écoulement sont des signes d'infection à signaler."
  },
  {
    question: "Quel besoin de Maslow correspond à l'autonomie ?",
    answers: ["Physiologique", "Sécurité", "Estime de soi", "Appartenance"],
    correctAnswer: 2,
    explanation: "L'autonomie répond au besoin d'estime de soi dans la pyramide de Maslow."
  }
];

const SLIDES = [
  // PARTIE 1: INTRODUCTION (Slides 1-4)
  {
    id: 1,
    type: 'title',
    title: "Activité 1",
    subtitle: "Les différents accompagnements réalisés dans le quotidien de l'enfant",
    description: "En lien avec les besoins fondamentaux de Virginia Henderson et la pyramide de Maslow",
    icon: BookOpen,
    color: '#E75480',
    narration: "Bienvenue dans cette présentation sur l'Activité 1 du Diplôme d'État d'Auxiliaire de Puériculture. Nous allons explorer les différents accompagnements réalisés dans le quotidien de l'enfant."
  },
  {
    id: 2,
    type: 'table_of_contents',
    title: "Sommaire de la Formation",
    subtitle: "Cliquez sur une section pour y accéder directement",
    sections: [
      { title: "1. Introduction & Théorie", slides: "3-5", targetSlide: 3, color: "#9B59B6", icon: "BookOpen" },
      { title: "2. L'Alimentation", slides: "6-31", targetSlide: 6, color: "#E74C3C", icon: "Utensils", subsections: [
        { title: "Préparation du biberon", targetSlide: 7, icon: "Milk" },
        { title: "Carrousel biberon", targetSlide: 10, icon: "Play" },
        { title: "Conservation du lait", targetSlide: 16, icon: "Snowflake" },
        { title: "Quiz Alimentation", targetSlide: 31, icon: "BookOpen" }
      ]},
      { title: "3. Le Sommeil", slides: "32-38", targetSlide: 32, color: "#3498DB", icon: "Moon", subsections: [
        { title: "Quiz Sommeil", targetSlide: 38, icon: "BookOpen" }
      ]},
      { title: "4. Le Change Coucher", slides: "39-50", targetSlide: 39, color: "#8B5CF6", icon: "Baby", subsections: [
        { title: "Carrousel change", targetSlide: 43, icon: "Play" },
        { title: "Quiz Change Coucher", targetSlide: 50, icon: "BookOpen" }
      ]},
      { title: "5. Le Change Debout", slides: "51-57", targetSlide: 51, color: "#10B981", icon: "Baby", subsections: [
        { title: "Carrousel change debout", targetSlide: 54, icon: "Play" },
        { title: "Quiz Change Debout", targetSlide: 57, icon: "BookOpen" }
      ]},
      { title: "6. Le Lavage des Mains", slides: "58-62", targetSlide: 58, color: "#0EA5E9", icon: "Droplets", subsections: [
        { title: "Carrousel lavage mains", targetSlide: 59, icon: "Play" },
        { title: "Quiz Lavage Mains", targetSlide: 62, icon: "BookOpen" }
      ]},
      { title: "7. Le Bain", slides: "63-65", targetSlide: 63, color: "#0891B2", icon: "Droplets", subsections: [
        { title: "Carrousel bain", targetSlide: 64, icon: "Play" },
        { title: "Quiz Bain", targetSlide: 65, icon: "BookOpen" }
      ]},
      { title: "8. Soins du Cordon", slides: "66-68", targetSlide: 66, color: "#059669", icon: "Shield", subsections: [
        { title: "Carrousel cordon", targetSlide: 67, icon: "Play" },
        { title: "Quiz Cordon", targetSlide: 68, icon: "BookOpen" }
      ]},
      { title: "9. Autonomie", slides: "69-71", targetSlide: 69, color: "#F39C12", icon: "Baby", subsections: [
        { title: "Quiz Autonomie", targetSlide: 71, icon: "BookOpen" }
      ]},
      { title: "10. Sécurité Affective", slides: "72-74", targetSlide: 72, color: "#E91E63", icon: "Heart", subsections: [
        { title: "Quiz Sécurité", targetSlide: 74, icon: "BookOpen" }
      ]},
      { title: "11. Synthèse & Conclusion", slides: "75-77", targetSlide: 75, color: "#27AE60", icon: "BookOpen", subsections: [
        { title: "Quiz Général (20 questions)", targetSlide: 77, icon: "Trophy" }
      ]}
    ],
    color: '#E75480',
    narration: "Voici le sommaire de cette formation avec les quiz à la fin de chaque section. Le quiz général de 20 questions vous attend à la fin pour valider vos acquis."
  },
  {
    id: 3,
    type: 'theory',
    title: "Virginia Henderson",
    subtitle: "Les 14 besoins fondamentaux",
    image: IMAGES.virginiaHenderson,
    content: [
      "Virginia Henderson (1897-1996) est une infirmière américaine qui a développé un modèle de soins centré sur les besoins fondamentaux de l'être humain.",
      "Elle a identifié 14 besoins fondamentaux que l'auxiliaire de puériculture doit savoir reconnaître et satisfaire chez l'enfant :",
      "• Respirer • Boire et manger • Éliminer • Se mouvoir",
      "• Dormir et se reposer • Se vêtir et se dévêtir",
      "• Maintenir sa température • Être propre",
      "• Éviter les dangers • Communiquer",
      "• Agir selon ses croyances • S'occuper et se réaliser",
      "• Se récréer • Apprendre"
    ],
    color: '#9B59B6',
    narration: "Virginia Henderson, infirmière américaine née en 1897 et décédée en 1996, a développé un modèle de soins centré sur les besoins fondamentaux de l'être humain. Elle a identifié 14 besoins fondamentaux : respirer, boire et manger, éliminer, se mouvoir, dormir et se reposer, se vêtir et se dévêtir, maintenir sa température, être propre, éviter les dangers, communiquer, agir selon ses croyances, s'occuper et se réaliser, se récréer et apprendre."
  },
  {
    id: 4,
    type: 'theory',
    title: "Les 14 besoins fondamentaux",
    subtitle: "Schéma récapitulatif",
    image: IMAGES.henderson14Needs,
    content: [
      "Ce schéma illustre les 14 besoins fondamentaux de Virginia Henderson.",
      "Dans la pratique de l'auxiliaire de puériculture, chaque soin du quotidien répond à un ou plusieurs de ces besoins.",
      "L'AP doit observer l'enfant pour identifier les besoins non satisfaits et adapter ses actions."
    ],
    color: '#9B59B6',
    narration: "Ce schéma récapitule les 14 besoins fondamentaux de Virginia Henderson. Dans la pratique quotidienne, l'auxiliaire de puériculture doit observer l'enfant pour identifier ses besoins et adapter ses actions en conséquence. Chaque soin répond à un ou plusieurs de ces besoins fondamentaux."
  },
  {
    id: 5,
    type: 'theory',
    title: "Pyramide de Maslow",
    subtitle: "Hiérarchie des besoins humains",
    image: IMAGES.maslowPyramid,
    content: [
      "Abraham Maslow (1908-1970), psychologue américain, a hiérarchisé les besoins humains en 5 niveaux :",
      "1. Besoins physiologiques : manger, boire, dormir",
      "2. Besoin de sécurité : cadre stable, protection",
      "3. Besoin d'appartenance : liens affectifs, relations sociales",
      "4. Besoin d'estime : valorisation, confiance en soi",
      "5. Besoin d'accomplissement : autonomie, réalisation de soi",
      "L'auxiliaire de puériculture agit à tous ces niveaux au quotidien."
    ],
    color: '#9B59B6',
    narration: "Abraham Maslow, psychologue américain, a hiérarchisé les besoins humains en 5 niveaux formant une pyramide. À la base, les besoins physiologiques comme manger, boire et dormir. Puis le besoin de sécurité avec un cadre stable et une protection. Ensuite le besoin d'appartenance avec les liens affectifs et les relations sociales. Le besoin d'estime avec la valorisation et la confiance en soi. Et au sommet, le besoin d'accomplissement avec l'autonomie et la réalisation de soi."
  },
  
  // PARTIE 2: ALIMENTATION - Introduction (Slide 6)
  {
    id: 6,
    type: 'section',
    title: "1. L'alimentation de l'enfant",
    subtitle: "Répondre au besoin fondamental « Boire et manger »",
    icon: Utensils,
    image: IMAGES.babyFeeding,
    objectives: [
      "Répondre au besoin fondamental \"Boire et manger\"",
      "Assurer la croissance et le développement",
      "Favoriser l'autonomie et le plaisir alimentaire",
      "Prévenir les fausses routes et les carences"
    ],
    color: '#E74C3C',
    narration: "Commençons par l'alimentation de l'enfant. Les objectifs sont de répondre au besoin fondamental boire et manger, d'assurer la croissance et le développement de l'enfant, de favoriser son autonomie et le plaisir alimentaire, et de prévenir les fausses routes et les carences."
  },
  
  // PARTIE 3: BIBERON - Reconstitution lait artificiel (Slides 7-11)
  {
    id: 7,
    type: 'section',
    title: "Préparation du biberon",
    subtitle: "Reconstitution du lait artificiel infantile",
    icon: Milk,
    image: IMAGES.babyBottle,
    objectives: [
      "Maîtriser la technique de reconstitution du lait",
      "Connaître les quantités adaptées à chaque âge",
      "Respecter les règles d'hygiène essentielles",
      "Assurer la sécurité alimentaire de l'enfant"
    ],
    color: '#3498DB',
    narration: "Abordons maintenant la préparation du biberon de lait artificiel. C'est une compétence essentielle pour l'auxiliaire de puériculture. Les objectifs sont de maîtriser la technique de reconstitution du lait, de connaître les quantités adaptées à chaque âge, de respecter les règles d'hygiène et d'assurer la sécurité alimentaire de l'enfant."
  },
  {
    id: 8,
    type: 'highlight',
    title: "La règle d'or de reconstitution",
    subtitle: "À retenir absolument",
    mainRule: "1 mesurette rase = 30 ml d'eau",
    explanation: [
      "Pour 90 ml d'eau → 3 mesurettes",
      "Pour 120 ml d'eau → 4 mesurettes",
      "Pour 150 ml d'eau → 5 mesurettes",
      "Pour 180 ml d'eau → 6 mesurettes",
      "Pour 210 ml d'eau → 7 mesurettes",
      "Pour 240 ml d'eau → 8 mesurettes"
    ],
    warning: "Ne jamais modifier ce dosage : trop concentré = risque rénal, trop dilué = carences nutritionnelles",
    color: '#E74C3C',
    narration: "La règle d'or à retenir est : une mesurette rase de poudre pour 30 millilitres d'eau. Ainsi, pour 90 ml d'eau vous mettrez 3 mesurettes, pour 120 ml 4 mesurettes, et ainsi de suite. Ne jamais modifier ce dosage : un lait trop concentré présente un risque rénal, un lait trop dilué entraîne des carences nutritionnelles."
  },
  {
    id: 9,
    type: 'table',
    title: "Quantités selon l'âge",
    subtitle: "Repères indicatifs (à adapter selon les besoins de chaque enfant)",
    tableData: [
      { age: "0 à 1 mois", quantite: "6 à 8 biberons", volume: "60 à 90 ml", poudre: "2 à 3 mesurettes" },
      { age: "1 à 2 mois", quantite: "5 à 6 biberons", volume: "120 à 150 ml", poudre: "4 à 5 mesurettes" },
      { age: "2 à 3 mois", quantite: "5 biberons", volume: "150 à 180 ml", poudre: "5 à 6 mesurettes" },
      { age: "3 à 4 mois", quantite: "4 à 5 biberons", volume: "180 à 210 ml", poudre: "6 à 7 mesurettes" },
      { age: "4 à 6 mois", quantite: "4 biberons", volume: "210 à 240 ml", poudre: "7 à 8 mesurettes" },
      { age: "6 à 12 mois", quantite: "2 à 3 biberons", volume: "240 ml", poudre: "8 mesurettes" }
    ],
    note: "Ces quantités sont des repères. L'enfant régule naturellement ses besoins. Ne jamais forcer un enfant à finir son biberon.",
    color: '#9B59B6',
    narration: "Voici les quantités indicatives selon l'âge. De 0 à 1 mois, prévoyez 6 à 8 biberons de 60 à 90 ml. De 1 à 2 mois, 5 à 6 biberons de 120 à 150 ml. Ces quantités sont des repères, l'enfant régule naturellement ses besoins."
  },
  {
    id: 10,
    type: 'carousel',
    title: "Les 7 étapes de préparation",
    subtitle: "Technique professionnelle - Diaporama interactif",
    color: '#E75480',
    narration: "Voici les 7 étapes de préparation en images. Premièrement, lavez-vous soigneusement les mains. Deuxièmement, préparez un plan de travail propre. Troisièmement, versez l'eau en premier. Quatrièmement, ajoutez la poudre. Cinquièmement, fermez et agitez. Sixièmement, vérifiez la température. Septièmement, donnez le biberon immédiatement."
  },
  {
    id: 11,
    type: 'content',
    title: "Règles d'hygiène essentielles",
    subtitle: "Pour la sécurité de l'enfant",
    icon: AlertTriangle,
    items: [
      { title: "Biberon consommé dans l'heure", desc: "Au-delà, jeter le reste (risque bactérien)" },
      { title: "Ne jamais réchauffer un biberon entamé", desc: "Prolifération bactérienne rapide" },
      { title: "Nettoyage immédiat après utilisation", desc: "Rincer puis laver au goupillon avec du liquide vaisselle" },
      { title: "Biberon propre et sec", desc: "Un biberon bien lavé et séché est suffisant pour un usage quotidien" },
      { title: "Ne pas chauffer au micro-ondes", desc: "Risque de points chauds pouvant brûler l'enfant" }
    ],
    highlight: "La stérilisation n'est plus recommandée systématiquement. Un lavage soigneux au liquide vaisselle et un séchage complet suffisent.",
    color: '#E67E22',
    narration: "Les règles d'hygiène sont primordiales. Le biberon doit être consommé dans l'heure. Ne jamais réchauffer un biberon entamé. Important : la stérilisation n'est plus recommandée de manière systématique. Un biberon bien lavé et séché est suffisant pour un usage quotidien."
  },

  // PARTIE 4: ALLAITEMENT MATERNEL (Slides 11-14)
  {
    id: 12,
    type: 'section',
    title: "L'allaitement maternel",
    subtitle: "Rôle de l'auxiliaire de puériculture",
    icon: Heart,
    image: IMAGES.breastfeeding1,
    objectives: [
      "Informer et soutenir les parents dans leur choix",
      "Accompagner la mère allaitante avec bienveillance",
      "Faciliter la poursuite de l'allaitement en collectivité",
      "Connaître les règles de conservation du lait maternel"
    ],
    color: '#E75480',
    narration: "Passons maintenant à l'allaitement maternel. Le rôle de l'auxiliaire de puériculture est d'informer et soutenir les parents, d'accompagner la mère allaitante avec bienveillance, et de faciliter la poursuite de l'allaitement même après la reprise du travail."
  },
  {
    id: 13,
    type: 'content',
    title: "Accompagner l'allaitement",
    subtitle: "Mission des professionnels de la petite enfance",
    image: IMAGES.breastfeeding2,
    actions: [
      { title: "Informer les parents", desc: "Sur l'intérêt de poursuivre l'allaitement après la reprise du travail" },
      { title: "Encourager le projet", desc: "Faciliter le quotidien des familles allaitantes" },
      { title: "Soutenir sans juger", desc: "Accompagner avec bienveillance dans leur démarche" },
      { title: "Cohérence des pratiques", desc: "S'inscrire dans une recherche de cohérence au niveau régional" }
    ],
    highlight: "Même en cas d'allaitement exclusif, les familles fourniront une boîte de lait en poudre au cas où le stock de lait maternel ne serait pas suffisant.",
    color: '#E75480',
    narration: "Il est de la mission des professionnels d'informer les parents de l'intérêt de poursuivre l'allaitement après la reprise du travail, d'encourager leur projet et de faciliter leur quotidien, de les soutenir dans leur démarche, et de s'inscrire dans une cohérence des pratiques."
  },
  {
    id: 14,
    type: 'content',
    title: "Préparer l'accueil d'un enfant allaité",
    subtitle: "Options pour la mère et l'enfant",
    actions: [
      { title: "Allaitement exclusif sur place", desc: "La mère peut venir allaiter au sein pendant le temps d'accueil" },
      { title: "Lait maternel frais", desc: "Apport quotidien de lait réfrigéré par les parents" },
      { title: "Lait maternel congelé", desc: "Stocks possibles sur le lieu d'accueil selon l'organisation" },
      { title: "Alimentation mixte", desc: "Complément de préparation infantile et/ou diversification" }
    ],
    highlight: "Certains enfants ne se nourrissent pas pendant un temps d'accueil court et tètent au retour de leur mère.",
    color: '#E75480',
    narration: "Plusieurs possibilités s'offrent à la mère selon l'âge de l'enfant. L'allaitement exclusif peut être poursuivi en utilisant le lait de la mère, frais ou congelé. La mère peut aussi venir allaiter sur place, ce qui adoucit la séparation et aide au maintien de la lactation."
  },
  {
    id: 15,
    type: 'positions',
    title: "Les postures d'allaitement",
    subtitle: "Différentes positions pour le confort de la mère et de l'enfant",
    positions: [
      { 
        name: "Position de la madone",
        desc: "La plus classique. Bébé face au sein, corps contre corps, tête dans le creux du coude.",
        image: IMAGES.breastfeeding1
      },
      { 
        name: "Position de la madone inversée",
        desc: "Similaire mais la tête du bébé est soutenue par la main opposée au sein.",
        image: IMAGES.breastfeeding2
      },
      { 
        name: "Position allongée",
        desc: "Mère et bébé allongés face à face. Idéale pour les tétées nocturnes ou de repos.",
        image: IMAGES.breastfeeding3
      }
    ],
    tips: [
      "Installer confortablement la mère avec des coussins si nécessaire",
      "Vérifier la bonne prise du sein (bouche grande ouverte, menton contre le sein)",
      "Préserver l'intimité de la mère",
      "Proposer un espace calme et discret"
    ],
    color: '#E75480',
    narration: "Il existe plusieurs postures d'allaitement. La position de la madone est la plus classique, avec le bébé face au sein et la tête dans le creux du coude. La position de la madone inversée permet un meilleur contrôle de la tête. La position allongée est idéale pour les tétées de repos. L'important est d'installer confortablement la mère et de vérifier la bonne prise du sein."
  },

  // PARTIE 5: CONSERVATION DU LAIT MATERNEL (Slides 15-21)
  {
    id: 16,
    type: 'section',
    title: "Conservation du lait maternel",
    subtitle: "Règles essentielles pour la sécurité de l'enfant",
    icon: Snowflake,
    image: IMAGES.milkStorage,
    objectives: [
      "Connaître les caractéristiques du lait maternel",
      "Maîtriser les règles de recueil et d'hygiène",
      "Respecter les durées et températures de conservation",
      "Assurer la traçabilité du lait maternel"
    ],
    color: '#3498DB',
    narration: "Abordons maintenant la conservation du lait maternel. C'est un sujet essentiel pour les professionnels accueillant des enfants allaités. Les objectifs sont de connaître les caractéristiques du lait, de maîtriser les règles d'hygiène, et de respecter les durées de conservation."
  },
  {
    id: 17,
    type: 'content',
    title: "Couleur, aspect et odeur du lait maternel",
    subtitle: "Ce qu'il faut savoir",
    actions: [
      { title: "La couleur peut varier", desc: "Selon l'alimentation de la mère, certains médicaments... C'est normal et adapté aux besoins de l'enfant." },
      { title: "L'aspect peut changer", desc: "Après réfrigération ou congélation, on observe une séparation entre les corps gras et la fraction aqueuse. Agiter doucement pour homogénéiser." },
      { title: "L'odeur peut se modifier", desc: "Après conservation, l'odeur peut changer mais le lait reste sans danger pour le bébé." }
    ],
    highlight: "Si l'enfant est allaité au sein depuis la naissance, ce lait est parfaitement adapté à ses besoins nutritionnels.",
    color: '#3498DB',
    narration: "La couleur du lait maternel peut varier selon l'alimentation de la mère ou certains médicaments, c'est tout à fait normal. La conservation peut modifier l'aspect du lait, avec une séparation visible qu'il suffit d'agiter doucement. L'odeur peut aussi changer mais le lait reste sûr pour l'enfant."
  },
  {
    id: 18,
    type: 'content',
    title: "Recueil du lait maternel",
    subtitle: "À domicile ou sur le lieu de travail",
    actions: [
      { title: "Lavage soigneux des mains", desc: "Indispensable avant toute manipulation" },
      { title: "Matériel propre", desc: "Tire-lait et récipients lavés au liquide vaisselle et bien rincés" },
      { title: "Après utilisation", desc: "Démonter le kit, rincer à l'eau froide, laver à l'eau chaude savonneuse, égoutter sur serviette papier" },
      { title: "Conditionnement", desc: "Préférer le récipient qui servira au repas de l'enfant pour éviter les manipulations supplémentaires" }
    ],
    highlight: "Les pièces du tire-lait doivent être lavées dans une cuvette propre, jamais directement dans l'évier pour minimiser la contamination.",
    color: '#3498DB',
    narration: "Le recueil du lait maternel nécessite un lavage soigneux des mains avant toute manipulation. Le matériel doit être propre. Après utilisation, démonter le kit, rincer à l'eau froide, laver à l'eau chaude savonneuse et égoutter. Les pièces doivent être lavées dans une cuvette propre, pas dans l'évier."
  },
  {
    id: 19,
    type: 'conservation',
    title: "Durées de conservation",
    subtitle: "Règles strictes à respecter",
    conservationRules: [
      { type: "Réfrigérateur", temp: "0°C à 4°C", duree: "5 jours maximum", icon: Thermometer, color: "#3498DB" },
      { type: "Congélateur", temp: "-18°C", duree: "4 mois maximum", icon: Snowflake, color: "#9B59B6" },
      { type: "Après décongélation", temp: "Au réfrigérateur", duree: "24 heures maximum", icon: Thermometer, color: "#E67E22" }
    ],
    importantRules: [
      "La durée de conservation commence à la date de la 1ère expression",
      "Stocker sur les clayettes du réfrigérateur, jamais dans la porte",
      "Le lait décongelé ne doit JAMAIS être recongelé",
      "Placer un thermomètre dans le réfrigérateur pour contrôler la température"
    ],
    color: '#3498DB',
    narration: "Au réfrigérateur entre 0 et 4 degrés, le lait se conserve 5 jours maximum. Au congélateur à moins 18 degrés, il se conserve 4 mois maximum. Une fois décongelé, il doit être consommé dans les 24 heures et ne jamais être recongelé."
  },
  {
    id: 20,
    type: 'content',
    title: "Transport et réception du lait",
    subtitle: "Respect de la chaîne du froid",
    actions: [
      { title: "Transport", desc: "Dans une glacière ou sac isotherme avec packs de réfrigération, lait étiqueté" },
      { title: "Vérification à l'arrivée", desc: "Glacière propre, packs de réfrigération, température respectée" },
      { title: "Étiquetage obligatoire", desc: "Nom de l'enfant, date d'expression, dates de congélation/décongélation si applicable" },
      { title: "Contrôle de température", desc: "Entre 0°C et 4°C si réfrigéré, en-dessous de 0°C si congelé" }
    ],
    highlight: "La glacière et les packs de réfrigération doivent être régulièrement nettoyés.",
    color: '#2ECC71',
    narration: "Le lait maternel doit être transporté dans une glacière avec des packs de réfrigération. À l'arrivée, le professionnel vérifie que la chaîne du froid a été respectée et que les récipients sont correctement étiquetés avec le nom de l'enfant et les dates importantes."
  },
  {
    id: 21,
    type: 'content',
    title: "Décongélation et préparation du repas",
    subtitle: "Méthodes sûres et adaptées",
    actions: [
      { title: "Décongélation au réfrigérateur", desc: "Méthode recommandée, placer le lait congelé au réfrigérateur jusqu'à utilisation" },
      { title: "Décongélation rapide", desc: "Dans un récipient d'eau chaude (max 37°C), sans que l'eau touche le couvercle" },
      { title: "Réchauffage", desc: "Passer sous l'eau chaude ou au chauffe-biberon. La plupart des bébés préfèrent le lait tiédi (35°C)" },
      { title: "Durée du repas", desc: "La prise d'un même biberon ne peut durer plus d'1 heure" }
    ],
    highlight: "Le four micro-ondes est TOTALEMENT INTERDIT car il détruit les composants sensibles du lait maternel (immunoglobulines, lymphocytes...).",
    color: '#E74C3C',
    narration: "Le lait peut être décongelé au réfrigérateur ou rapidement dans de l'eau chaude à maximum 37 degrés. Le four micro-ondes est totalement interdit car il détruit les composants bénéfiques du lait maternel. La prise d'un biberon ne peut pas durer plus d'une heure."
  },
  {
    id: 22,
    type: 'content',
    title: "Quantités à prévoir",
    subtitle: "Repères pratiques pour les professionnels",
    actions: [
      { title: "Moyenne quotidienne", desc: "Un enfant allaité de 1 à 6 mois prend 750 à 800 ml/24h (variable de 650 à 1200 ml)" },
      { title: "Conseil de fractionnement", desc: "Prévoir plusieurs petits récipients (50-80 ml) pour éviter le gaspillage" },
      { title: "Pour 8h d'accueil", desc: "Prévoir 3 à 4 récipients de 50 à 80 ml et ajuster ensuite" },
      { title: "Lait non consommé", desc: "Si partiellement consommé, conserver 1 heure maximum puis jeter le reste" }
    ],
    highlight: "Autant que possible, fractionner les quantités pour éviter d'écarter du lait non consommé.",
    color: '#F39C12',
    narration: "En moyenne, un enfant allaité de 1 à 6 mois prend 750 à 800 ml par jour. Pour 8 heures d'accueil, prévoir 3 à 4 récipients de 50 à 80 ml. Il est important de fractionner pour éviter de gaspiller ce précieux lait maternel."
  },

  // PARTIE 6: ALIMENTATION DES MOYENS/GRANDS - Position et techniques
  {
    id: 23,
    type: 'content',
    title: "La position de l'enfant pendant le repas",
    subtitle: "Un élément essentiel pour la sécurité et l'autonomie",
    image: "https://images.pexels.com/photos/1001914/pexels-photo-1001914.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    actions: [
      { title: "Petite chaise et petite table", desc: "L'enfant doit avoir les pieds qui touchent le sol pour une bonne stabilité" },
      { title: "Position assise stable", desc: "Le dos droit, les coudes à hauteur de la table" },
      { title: "Pour les plus petits", desc: "Si l'enfant est trop petit, il prend son repas sur les genoux de la professionnelle" },
      { title: "Pas de chaise haute systématique", desc: "Privilégier le mobilier adapté à la taille de l'enfant" }
    ],
    highlight: "Une bonne position favorise l'autonomie, la déglutition et prévient les fausses routes.",
    color: '#E74C3C',
    narration: "La position de l'enfant pendant le repas est essentielle. L'enfant doit être assis sur une petite chaise à une petite table, avec les pieds qui touchent le sol pour une bonne stabilité. Si l'enfant est trop petit pour ce mobilier, il prend son repas sur les genoux de la professionnelle. Évitez la chaise haute systématique et privilégiez un mobilier adapté à la taille de l'enfant."
  },
  {
    id: 24,
    type: 'content',
    title: "La technique de la double cuillère",
    subtitle: "Favoriser l'autonomie tout en accompagnant l'enfant",
    actions: [
      { title: "Principe", desc: "L'enfant a sa propre cuillère qu'il manipule, la professionnelle en a une autre pour l'aider" },
      { title: "L'enfant explore", desc: "Il touche, porte à la bouche, s'entraîne à la coordination main-bouche" },
      { title: "L'adulte accompagne", desc: "Elle complète avec sa cuillère pour assurer que l'enfant mange suffisamment" },
      { title: "Progression", desc: "Petit à petit, l'adulte intervient de moins en moins" }
    ],
    highlight: "La double cuillère permet à l'enfant d'apprendre à manger seul tout en étant accompagné.",
    color: '#E74C3C',
    narration: "La technique de la double cuillère est très efficace pour développer l'autonomie. L'enfant a sa propre cuillère qu'il manipule librement, pendant que la professionnelle utilise une autre cuillère pour l'aider et s'assurer qu'il mange suffisamment. L'enfant explore, touche les aliments et s'entraîne à la coordination. Progressivement, l'adulte intervient de moins en moins."
  },
  {
    id: 25,
    type: 'section',
    title: "La DME",
    subtitle: "Diversification Menée par l'Enfant",
    icon: Baby,
    image: "https://images.pexels.com/photos/7491222/pexels-photo-7491222.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    objectives: [
      "Comprendre les principes de la DME",
      "Connaître les avantages et les précautions",
      "Savoir proposer des aliments adaptés",
      "Respecter le rythme de l'enfant"
    ],
    color: '#9B59B6',
    narration: "La Diversification Menée par l'Enfant, ou DME, est une approche de la diversification alimentaire où l'enfant mange seul des morceaux d'aliments qu'il porte lui-même à sa bouche, sans passer par les purées."
  },
  {
    id: 26,
    type: 'content',
    title: "Principes de la DME",
    subtitle: "Laisser l'enfant découvrir et manger seul",
    actions: [
      { title: "Pas de purées", desc: "L'enfant mange directement des morceaux d'aliments mous qu'il saisit avec ses mains" },
      { title: "Autonomie totale", desc: "L'enfant porte lui-même les aliments à sa bouche, à son rythme" },
      { title: "Découverte sensorielle", desc: "L'enfant explore les textures, couleurs, odeurs et goûts" },
      { title: "Respect du réflexe nauséeux", desc: "Normal et protecteur, il permet à l'enfant d'apprendre à gérer les morceaux" }
    ],
    highlight: "La DME favorise l'autonomie, la motricité fine et une relation positive avec l'alimentation.",
    color: '#9B59B6',
    narration: "Avec la DME, on ne propose pas de purées. L'enfant mange directement des morceaux d'aliments mous qu'il saisit avec ses mains et porte lui-même à sa bouche. Cette approche favorise la découverte sensorielle et l'autonomie. Le réflexe nauséeux est normal et protège l'enfant pendant qu'il apprend à gérer les morceaux."
  },
  {
    id: 27,
    type: 'content',
    title: "Aliments adaptés à la DME",
    subtitle: "Sécurité et adaptation selon l'âge",
    actions: [
      { title: "Forme des aliments", desc: "En bâtonnets ou lanières que l'enfant peut saisir facilement (taille du poing)" },
      { title: "Texture", desc: "Aliments mous qui s'écrasent entre le pouce et l'index (banane, avocat, légumes cuits)" },
      { title: "À éviter", desc: "Aliments ronds, durs, collants (raisins entiers, cacahuètes, carottes crues)" },
      { title: "Progression", desc: "Introduire progressivement des textures plus fermes selon la maîtrise de l'enfant" }
    ],
    highlight: "TOUJOURS superviser l'enfant pendant le repas et s'assurer qu'il est assis correctement.",
    color: '#9B59B6',
    narration: "Pour la DME, les aliments doivent être en bâtonnets de la taille du poing de l'enfant, avec une texture molle qui s'écrase facilement. On évite les aliments ronds comme les raisins entiers, les aliments durs comme les carottes crues, et les aliments collants. Toujours superviser l'enfant pendant le repas."
  },
  {
    id: 28,
    type: 'quantites',
    title: "Quantités alimentaires par âge",
    subtitle: "Repères pour une alimentation équilibrée",
    quantitesData: [
      { age: "6-8 mois", lait: "500-600 ml/jour", feculents: "2-3 c. à soupe", legumes: "2-3 c. à soupe", proteines: "10g (2 c. café)", fruits: "Compote 50-100g" },
      { age: "9-12 mois", lait: "500 ml/jour", feculents: "3-4 c. à soupe", legumes: "4-5 c. à soupe", proteines: "20g (4 c. café)", fruits: "100g" },
      { age: "1-2 ans", lait: "500 ml/jour", feculents: "4-5 c. à soupe", legumes: "5-6 c. à soupe", proteines: "30g viande/poisson/œuf", fruits: "100-150g" },
      { age: "2-3 ans", lait: "500 ml/jour", feculents: "5-6 c. à soupe", legumes: "100g", proteines: "40g", fruits: "150g" }
    ],
    tips: [
      "Ces quantités sont des repères, chaque enfant a des besoins différents",
      "Respecter les signaux de faim et de satiété de l'enfant",
      "Proposer de l'eau à volonté pendant et entre les repas",
      "Éviter le sel, le sucre ajouté et le miel avant 1 an"
    ],
    color: '#2ECC71',
    narration: "Voici les repères de quantités par âge. De 6 à 8 mois, l'enfant a besoin de 500 à 600 ml de lait par jour, complété par quelques cuillères de légumes et féculents. Les quantités augmentent progressivement. Ces repères sont indicatifs, chaque enfant a des besoins différents. Respectez toujours les signaux de faim et de satiété."
  },
  {
    id: 29,
    type: 'content',
    title: "Équilibre alimentaire au quotidien",
    subtitle: "Les groupes d'aliments essentiels",
    actions: [
      { title: "Produits laitiers", desc: "3 à 4 portions/jour (lait, yaourt, fromage) pour le calcium" },
      { title: "Féculents", desc: "À chaque repas (pain, pâtes, riz, pommes de terre) pour l'énergie" },
      { title: "Fruits et légumes", desc: "5 portions/jour pour les vitamines et fibres" },
      { title: "Protéines", desc: "1 à 2 fois/jour (viande, poisson, œuf) pour la croissance" },
      { title: "Matières grasses", desc: "Ajout modéré d'huile végétale (colza, olive) pour les acides gras essentiels" }
    ],
    highlight: "L'eau est la seule boisson indispensable. Pas de jus de fruits ni de boissons sucrées.",
    color: '#2ECC71',
    narration: "Pour un équilibre alimentaire, l'enfant a besoin de 3 à 4 portions de produits laitiers, des féculents à chaque repas, 5 portions de fruits et légumes, et des protéines 1 à 2 fois par jour. L'eau est la seule boisson indispensable, évitez les jus et boissons sucrées."
  },
  {
    id: 30,
    type: 'introduction_aliments',
    title: "Introduction des aliments selon l'âge",
    subtitle: "Calendrier de la diversification alimentaire",
    introductionData: [
      { age: "4-6 mois", aliments: "Légumes (carottes, courgettes, haricots verts), fruits cuits (pomme, poire, banane)", remarques: "Textures lisses, un aliment à la fois" },
      { age: "6-7 mois", aliments: "Pommes de terre, patate douce, céréales infantiles, viande/poisson mixés", remarques: "Introduction des protéines (10g/jour)" },
      { age: "7-8 mois", aliments: "Légumineuses (lentilles), fromages pasteurisés, jaune d'œuf", remarques: "Textures moins lisses, petits morceaux fondants" },
      { age: "9-12 mois", aliments: "Œuf entier, poissons gras, pain, pâtes, riz", remarques: "Morceaux, finger food, cuillère autonome" },
      { age: "12-18 mois", aliments: "Lait de vache entier, crudités râpées, fruits à coque écrasés", remarques: "Alimentation familiale adaptée" },
      { age: "Après 3 ans", aliments: "Miel, fruits à coque entiers", remarques: "Surveillance fausses routes" }
    ],
    alertes: [
      "Avant 1 an : éviter le miel (risque de botulisme), le lait de vache cru, le sel et le sucre ajoutés",
      "Avant 3 ans : éviter les fruits à coque entiers (risque d'étouffement)",
      "Allergènes (arachide, œuf, poisson...) : peuvent être introduits dès 4-6 mois, un par un"
    ],
    color: '#E67E22',
    narration: "Voici le calendrier d'introduction des aliments. Dès 4-6 mois, on commence par les légumes et fruits cuits en textures lisses. À 6-7 mois, on introduit les protéines. Vers 9-12 mois, l'enfant peut manger des morceaux. Attention, avant 1 an on évite le miel et le lait de vache cru. Les fruits à coque entiers ne sont autorisés qu'après 3 ans pour éviter les étouffements."
  },

  // Quiz Alimentation
  {
    id: 31,
    type: 'quiz',
    title: "Quiz - L'Alimentation",
    subtitle: "Testez vos connaissances sur l'alimentation",
    quizType: 'alimentation',
    color: '#E74C3C',
    narration: "C'est l'heure du quiz ! Testez vos connaissances sur l'alimentation du jeune enfant."
  },

  // PARTIE 7: LE SOMMEIL
  {
    id: 32,
    type: 'section',
    title: "2. Le sommeil",
    subtitle: "Répondre au besoin « Dormir et se reposer »",
    icon: Moon,
    image: IMAGES.babySleeping,
    objectives: [
      "Répondre au besoin \"Dormir et se reposer\"",
      "Favoriser la maturation cérébrale",
      "Préserver l'équilibre émotionnel",
      "Respecter le rythme individuel de chaque enfant"
    ],
    color: '#3498DB',
    narration: "Passons maintenant au sommeil. Le sommeil joue un rôle fondamental dans le développement de l'enfant."
  },
  {
    id: 33,
    type: 'content',
    title: "Le sommeil - Actions selon l'âge",
    image: IMAGES.babySleeping2,
    sections: [
      { title: "Chez le bébé", items: ["Couchage sur le dos (prévention MSN)", "Lit vide sans objets", "Surveillance régulière"] },
      { title: "Chez le moyen/grand", items: ["Rituel rassurant avant le coucher", "Respect du rythme individuel", "Environnement calme et sécurisant"] }
    ],
    highlight: "Le manque de sommeil impacte l'alimentation, l'humeur et les apprentissages.",
    color: '#3498DB',
    narration: "Chez le bébé, le couchage doit être sur le dos pour prévenir la mort subite du nourrisson. Le lit doit être vide. Chez les enfants plus grands, un rituel rassurant est important."
  },
  {
    id: 34,
    type: 'train_sommeil',
    title: "Le train du sommeil",
    subtitle: "Comprendre les cycles de sommeil selon l'âge",
    trainImage: "https://customer-assets.emergentagent.com/job_0bdb7109-8029-4d81-a486-71beb721288a/artifacts/r593qsp6_image.png",
    cycles: [
      { age: "De 0 à 3 mois", duree: "50 min", phases: ["Endormissement", "Sommeil agité (paradoxal) - Rêves", "Sommeil calme (lent)"], info: "À 1 an, l'enfant peut encore se réveiller 4 ou 5 fois par nuit" },
      { age: "De 3 à 9 mois", duree: "70 min", phases: ["Endormissement", "Sommeil paradoxal - Rêves", "Sommeil lent léger", "Sommeil lent profond"], info: "Il mémorise et récupère" },
      { age: "De 9 mois à 3 ans", duree: "70 min", phases: ["Endormissement", "Sommeil lent léger", "Sommeil lent profond", "Sommeil paradoxal - Rêves"], info: "Il récupère et grandit" },
      { age: "À partir de 3 ans", duree: "90 à 120 min", phases: ["Sommeil lent léger", "Sommeil lent profond", "Sommeil lent très profond", "Sommeil paradoxal - Rêves"], info: "Cycles adultes" }
    ],
    color: '#9B59B6',
    narration: "Le train du sommeil illustre l'évolution des cycles de sommeil selon l'âge. De 0 à 3 mois, les cycles sont courts de 50 minutes. De 3 à 9 mois, ils passent à 70 minutes. À partir de 3 ans, l'enfant atteint les cycles adultes de 90 à 120 minutes."
  },
  {
    id: 35,
    type: 'prevention_min',
    title: "Prévention de la Mort Inattendue du Nourrisson",
    subtitle: "Mesures essentielles pour un couchage sécurisé",
    alertTitle: "La MIN (Mort Inattendue du Nourrisson) peut être évitée",
    mesures: [
      { icon: "🌡️", title: "Température de la chambre", desc: "Maintenir entre 18°C et 20°C - jamais plus de 21°C", danger: true },
      { icon: "🛏️", title: "Lit vide et sécurisé", desc: "Rien de dangereux : pas de peluches, coussins, tours de lit, couettes", danger: true },
      { icon: "👶", title: "Position sur le dos", desc: "Toujours coucher bébé sur le dos, jamais sur le ventre ou le côté", danger: true },
      { icon: "🧥", title: "Gigoteuse obligatoire", desc: "De 0 à 18 mois : uniquement gigoteuse adaptée à la saison", danger: true },
      { icon: "❌", title: "Pas de couverture", desc: "Interdite avant 18 mois - risque d'étouffement", danger: true },
      { icon: "🏠", title: "Chambre des parents", desc: "Dans la même chambre les 6 premiers mois, mais dans son propre lit", danger: false }
    ],
    warning: "Ces mesures sont VITALES. La plupart des cas de MIN sont liés à un environnement de sommeil non sécurisé.",
    color: '#E74C3C',
    narration: "La prévention de la mort inattendue du nourrisson repose sur des mesures essentielles. La température de la chambre doit être entre 18 et 20 degrés. Le lit doit être vide, sans peluches ni coussins. L'enfant doit dormir sur le dos. De 0 à 18 mois, utilisez uniquement une gigoteuse, jamais de couverture."
  },
  {
    id: 36,
    type: 'surveillance_dortoir',
    title: "Surveillance du dortoir en EAJE",
    subtitle: "Organisation sécuritaire et attitude professionnelle",
    sections: [
      {
        title: "Organisation sécuritaire",
        icon: "👁️",
        items: [
          "Visites régulières et tracées (ex : toutes les 5 minutes selon protocole interne)",
          "Observation visuelle de chaque enfant",
          "Vérification de la posture de couchage",
          "Écoute des bruits inhabituels (respiration, pleurs)"
        ]
      },
      {
        title: "Points de vigilance",
        icon: "⚠️",
        items: [
          "Température ambiante stable (18-20°C)",
          "Absence d'objets dangereux à portée",
          "Distance suffisante entre les lits",
          "Identification claire de chaque enfant"
        ]
      },
      {
        title: "Attitude professionnelle",
        icon: "👩‍⚕️",
        items: [
          "Silence respectueux pendant la sieste",
          "Lumière tamisée",
          "Rapidité d'intervention si besoin",
          "Traçabilité des incidents ou anomalies"
        ]
      }
    ],
    color: '#3498DB',
    narration: "La surveillance du dortoir en EAJE nécessite une organisation rigoureuse. Des visites régulières toutes les 5 minutes, l'observation de chaque enfant, la vérification des postures et l'écoute des bruits inhabituels sont essentiels. La température doit rester stable, les lits espacés et chaque enfant identifié. L'attitude professionnelle implique le silence, une lumière tamisée et la traçabilité de tout incident."
  },
  {
    id: 37,
    type: 'securite_sommeil',
    title: "Sécurité affective et sommeil",
    subtitle: "Le sommeil est un moment de séparation",
    intro: "Le sommeil représente une séparation temporaire avec les figures d'attachement. L'auxiliaire de puériculture favorise la sécurité affective par :",
    actions: [
      { icon: "💬", title: "Une parole douce et rassurante", desc: "Accompagner verbalement l'endormissement avec calme" },
      { icon: "🤗", title: "Une présence contenante", desc: "Être disponible et visible pour l'enfant" },
      { icon: "🏠", title: "Le respect des rituels familiaux", desc: "Adapter les pratiques compatibles avec la structure (doudou, chanson...)" },
      { icon: "🔄", title: "La stabilité des repères", desc: "Même lieu, même lit, mêmes rituels chaque jour" }
    ],
    conclusion: "Un enfant sécurisé s'endort plus sereinement",
    color: '#9B59B6',
    narration: "Le sommeil est un moment de séparation pour l'enfant. L'auxiliaire de puériculture favorise la sécurité affective par une parole douce et rassurante, une présence contenante, le respect des rituels familiaux compatibles avec la structure, et la stabilité des repères. Un enfant sécurisé s'endort plus sereinement."
  },

  // Quiz Sommeil
  {
    id: 38,
    type: 'quiz',
    title: "Quiz - Le Sommeil",
    subtitle: "Testez vos connaissances sur le sommeil",
    quizType: 'sommeil',
    color: '#3498DB',
    narration: "C'est l'heure du quiz ! Testez vos connaissances sur le sommeil de l'enfant."
  },

  // PARTIE 8: LE CHANGE DE L'ENFANT
  {
    id: 39,
    type: 'section',
    title: "Le Change de l'Enfant",
    subtitle: "Un temps relationnel individualisé",
    icon: Droplets,
    image: IMAGES.babyHygiene,
    objectives: [
      "Répondre aux besoins « Éliminer » et « Être propre »",
      "Prévenir les infections et irritations cutanées",
      "Favoriser l'observation clinique",
      "Accompagner l'autonomie progressive",
      "Maintenir la sécurité affective"
    ],
    color: '#2ECC71',
    narration: "Le change répond aux besoins fondamentaux d'éliminer, d'être propre, d'être en sécurité et de communiquer. Ce n'est pas un simple soin d'hygiène mais un temps relationnel individualisé."
  },
  {
    id: 40,
    type: 'change_cadre',
    title: "Cadre théorique du change",
    subtitle: "Henderson et Maslow",
    henderson: {
      title: "Besoins fondamentaux (Virginia Henderson)",
      items: ["Éliminer", "Être propre et protéger ses téguments", "Éviter les dangers", "Communiquer"]
    },
    maslow: {
      title: "Pyramide de Maslow",
      items: [
        { niveau: "Physiologiques", desc: "Propreté, confort" },
        { niveau: "Sécurité", desc: "Gestes doux, cadre stable" },
        { niveau: "Appartenance", desc: "Relation individualisée" }
      ]
    },
    conclusion: "Le change participe à la construction du schéma corporel et de l'image de soi.",
    color: '#3498DB',
    narration: "Le change s'inscrit dans les besoins fondamentaux de Virginia Henderson : éliminer, être propre, éviter les dangers et communiquer. Selon Maslow, il répond aux besoins physiologiques, de sécurité et d'appartenance."
  },
  {
    id: 41,
    type: 'change_objectifs',
    title: "Objectifs du change",
    subtitle: "Au-delà de l'hygiène",
    objectifs: [
      { icon: "🛡️", title: "Maintenir l'intégrité cutanée", color: "#2ECC71" },
      { icon: "🦠", title: "Prévenir érythème fessier et infections", color: "#E74C3C" },
      { icon: "😊", title: "Assurer le confort de l'enfant", color: "#F39C12" },
      { icon: "👁️", title: "Observer l'état général", color: "#3498DB" },
      { icon: "🚀", title: "Favoriser l'autonomie selon l'âge", color: "#9B59B6" }
    ],
    color: '#2ECC71',
    narration: "Les objectifs du change sont de maintenir l'intégrité cutanée, prévenir l'érythème fessier, assurer le confort, observer l'état général et favoriser l'autonomie."
  },
  {
    id: 42,
    type: 'change_preparation',
    title: "Préparation du soin",
    subtitle: "Organisation et matériel",
    materiel: {
      title: "Matériel nécessaire",
      items: ["Couche propre adaptée à la taille de l'enfant", "Gant et savon adapté à l'enfant", "Poubelle avec couvercle à ouverture pédale ou automatique", "Vêtements propres si besoin"]
    },
    organisation: {
      title: "Organisation",
      items: ["Préparer le matériel AVANT d'installer l'enfant", "Ne JAMAIS laisser l'enfant seul", "Adapter la hauteur du plan de change", "Vérifier la température de la pièce"]
    },
    color: '#F39C12',
    narration: "La préparation est essentielle. Préparez tout le matériel avant d'installer l'enfant et ne le quittez jamais des yeux."
  },
  {
    id: 43,
    type: 'change_carousel',
    title: "Les 10 étapes du change",
    subtitle: "Du lavage des mains au réhabillage - Diaporama interactif",
    color: '#8B5CF6',
    narration: "Voici les 10 étapes du change en images. Étape 1: lavage des mains avant le soin. Étape 2: nettoyage du contour de la table à langer. Étape 3: nettoyage de la surface en godille. Étape 4: préparation du matériel. Étape 5: expliquer à l'enfant. Étape 6: technique de l'enroulé. Étape 7: nettoyer d'avant vers l'arrière. Étape 8: mettre la couche propre. Étape 9: rhabiller l'enfant. Étape 10: lavage des mains après le soin."
  },
  {
    id: 44,
    type: 'change_technique',
    title: "Technique de l'enroulé",
    subtitle: "Déroulement du change moderne",
    alerte: "On ne lève plus les jambes en l'air pour éviter l'hyperpression abdominale, l'inconfort, le risque de reflux et la mise en tension du bassin.",
    etapes: [
      { num: 1, text: "Expliquer à l'enfant ce que l'on va faire" },
      { num: 2, text: "Défaire la couche" },
      { num: 3, text: "Tourner doucement l'enfant sur le côté" },
      { num: 4, text: "Nettoyer d'avant vers l'arrière" },
      { num: 5, text: "Retirer la couche sale en la roulant" },
      { num: 6, text: "Glisser la couche propre sous le bassin" },
      { num: 7, text: "Tourner l'enfant de l'autre côté" },
      { num: 8, text: "Ajuster la couche et réinstaller confortablement" }
    ],
    principe: "Le mouvement respecte l'axe physiologique du corps.",
    color: '#9B59B6',
    narration: "La technique de l'enroulé remplace le levé de jambes. On tourne doucement l'enfant sur le côté, on nettoie d'avant vers l'arrière, on retire la couche sale en la roulant et on glisse la couche propre. Ce mouvement respecte l'axe physiologique du corps."
  },
  {
    id: 45,
    type: 'change_age',
    title: "Adaptation selon l'âge",
    subtitle: "Du nourrisson au grand",
    tranches: [
      {
        age: "Nourrisson",
        icon: "🍼",
        actions: ["Parler doucement", "Maintenir contact visuel", "Sécuriser par la voix", "Observer selles (couleur, consistance)"]
      },
      {
        age: "Moyen (18 mois - 2 ans)",
        icon: "👦",
        actions: ["Proposer participation : \"tu tiens la couche ?\"", "Nommer les parties du corps", "Encourager la coopération"]
      },
      {
        age: "Grand (acquisition propreté)",
        icon: "👧",
        actions: ["Respecter le rythme individuel", "Proposer pot/toilettes sans pression", "Valoriser les réussites"]
      }
    ],
    color: '#E67E22',
    narration: "L'adaptation selon l'âge est essentielle. Pour le nourrisson, parler doucement et maintenir le contact visuel. Pour le moyen, proposer de participer. Pour le grand en acquisition de propreté, respecter le rythme et valoriser sans pression."
  },
  {
    id: 46,
    type: 'change_observation',
    title: "Observation clinique pendant le change",
    subtitle: "Un moment clé d'observation",
    observations: [
      { element: "Aspect des selles", detail: "Couleur, fréquence, consistance" },
      { element: "Odeur", detail: "Signaler toute odeur inhabituelle" },
      { element: "Peau", detail: "Rougeurs, mycoses, irritations" },
      { element: "Lésions", detail: "Plaies, ecchymoses" },
      { element: "Mobilisation", detail: "Douleur à la mobilisation" }
    ],
    alerte: "Toute anomalie doit être transmise à l'équipe immédiatement.",
    color: '#E74C3C',
    narration: "Le change est un moment clé d'observation. Observez l'aspect des selles, les odeurs inhabituelles, l'état de la peau, les éventuelles lésions et la réaction à la mobilisation. Toute anomalie doit être transmise."
  },
  {
    id: 47,
    type: 'change_prevention',
    title: "Prévention de l'érythème fessier",
    subtitle: "Mesures essentielles",
    mesures: [
      { icon: "🔄", text: "Change fréquent" },
      { icon: "💨", text: "Séchage soigneux par tamponnement" },
      { icon: "🧴", text: "Produits adaptés (sans parfum)" },
      { icon: "🌬️", text: "Aération si possible" },
      { icon: "👁️", text: "Surveillance des rougeurs" }
    ],
    color: '#2ECC71',
    narration: "Pour prévenir l'érythème fessier : changez fréquemment, séchez soigneusement, utilisez des produits adaptés, aérez si possible et surveillez les rougeurs."
  },
  {
    id: 48,
    type: 'change_relationnel',
    title: "Dimension relationnelle du change",
    subtitle: "Un temps privilégié",
    dimensions: [
      "Un moment d'individualisation",
      "Un temps privilégié de relation",
      "Un espace de communication",
      "Un soutien à la sécurité affective"
    ],
    attitudes: [
      { icon: "👁️", text: "Regard bienveillant" },
      { icon: "🤲", text: "Gestes lents et doux" },
      { icon: "💬", text: "Explication des gestes" },
      { icon: "🙈", text: "Respect de l'intimité" }
    ],
    color: '#E91E63',
    narration: "Le change est un moment d'individualisation et de communication. Adoptez un regard bienveillant, des gestes lents, expliquez ce que vous faites et respectez l'intimité de l'enfant."
  },
  {
    id: 49,
    type: 'change_autonomie',
    title: "Accompagnement vers l'autonomie",
    subtitle: "Vers 2-3 ans",
    actions: [
      { icon: "👖", text: "Proposer d'enlever le pantalon" },
      { icon: "🚽", text: "Inviter à tirer la chasse" },
      { icon: "🧼", text: "Se laver les mains ensemble" },
      { icon: "🗑️", text: "Mettre la couche à la poubelle" }
    ],
    conclusion: "L'autonomie développe l'estime de soi (Maslow)",
    color: '#9B59B6',
    narration: "Vers 2-3 ans, proposez à l'enfant de participer : enlever le pantalon, tirer la chasse, se laver les mains, jeter la couche. L'autonomie développe l'estime de soi."
  },

  // Quiz Change Coucher
  {
    id: 50,
    type: 'quiz',
    title: "Quiz - Le Change Coucher",
    subtitle: "Testez vos connaissances sur le change coucher",
    quizType: 'change_coucher',
    color: '#8B5CF6',
    narration: "C'est l'heure du quiz ! Testez vos connaissances sur le change coucher."
  },

  // SECTION CHANGE DEBOUT
  {
    id: 51,
    type: 'section',
    title: "Le Change Debout",
    subtitle: "Favoriser l'autonomie de l'enfant qui marche",
    icon: Baby,
    image: "https://static.prod-images.emergentagent.com/jobs/258d18fd-cb23-4690-a110-1da253b34772/images/7fe277d19244a80bfe638a8bb63129f72157ada3b291346563971aba3815f611.png",
    objectives: [
      "Respecter le développement psychomoteur",
      "Favoriser l'autonomie et la participation",
      "Préserver la dignité de l'enfant",
      "Accompagner vers l'acquisition de la propreté"
    ],
    color: '#10B981',
    narration: "Le change debout est proposé à l'enfant qui marche ou tient debout avec appui. Il favorise l'autonomie et la participation active tout en respectant le développement de l'enfant."
  },
  {
    id: 52,
    type: 'change_debout_theorie',
    title: "Fondements théoriques",
    subtitle: "Virginia Henderson et Maslow",
    henderson: {
      title: "Besoins fondamentaux (Henderson)",
      items: ["Éliminer", "Être propre et protéger ses téguments", "Se mouvoir", "Communiquer", "Être en sécurité"]
    },
    maslow: {
      title: "Pyramide de Maslow",
      items: ["Besoin physiologique (propreté)", "Besoin de sécurité (cadre stable)", "Besoin d'estime (faire seul)", "Besoin d'accomplissement (autonomie)"]
    },
    conclusion: "Le change debout participe fortement au développement de l'estime de soi",
    color: '#10B981',
    narration: "Le change debout répond aux besoins fondamentaux de Virginia Henderson : éliminer, être propre, se mouvoir et communiquer. Il s'inscrit aussi dans la pyramide de Maslow en favorisant l'estime de soi."
  },
  {
    id: 53,
    type: 'change_debout_quand',
    title: "À partir de quel âge ?",
    subtitle: "Adapter à chaque enfant",
    age: "18 à 24 mois",
    conditions: [
      { icon: "🚶", text: "L'enfant tient debout seul ou avec appui stable" },
      { icon: "🤚", text: "Il manifeste un intérêt pour l'autonomie" },
      { icon: "⚠️", text: "Toujours adapter à la maturité et à l'état du jour" }
    ],
    objectifs: [
      "Encourager la participation active",
      "Favoriser la conscience corporelle",
      "Soutenir l'acquisition de la propreté",
      "Limiter les tensions liées à l'opposition"
    ],
    image: "https://static.prod-images.emergentagent.com/jobs/258d18fd-cb23-4690-a110-1da253b34772/images/9e1e5d67d7b1b008dc18980c2249d2bbaa323d337af28c159dba613fef4556a5.png",
    color: '#10B981',
    narration: "Le change debout est proposé généralement entre 18 et 24 mois, lorsque l'enfant tient debout et montre un intérêt pour l'autonomie. Toujours adapter à l'état du jour."
  },
  {
    id: 54,
    type: 'change_debout_carousel',
    title: "Les étapes du change debout",
    subtitle: "Technique avec participation de l'enfant",
    color: '#10B981',
    narration: "Voici les étapes du change debout : préparer le matériel, expliquer à l'enfant, inviter à participer, nettoyer, mettre la couche propre, valoriser et lavage des mains ensemble."
  },
  {
    id: 55,
    type: 'change_debout_avantages',
    title: "Avantages et limites",
    subtitle: "Quand proposer le change debout",
    avantages: [
      { icon: "✅", text: "Autonomie renforcée" },
      { icon: "✅", text: "Meilleure coopération" },
      { icon: "✅", text: "Moins de conflits" },
      { icon: "✅", text: "Facilite l'acquisition de la propreté" }
    ],
    limites: [
      { icon: "⚠️", text: "Pas adapté aux selles importantes" },
      { icon: "⚠️", text: "Demande plus d'attention" },
      { icon: "⚠️", text: "Nécessite environnement sécurisé" },
      { icon: "⚠️", text: "Revenir au change allongé si besoin" }
    ],
    rappel: "Ne jamais laisser l'enfant seul. Toujours être attentif aux chutes.",
    image: "https://static.prod-images.emergentagent.com/jobs/258d18fd-cb23-4690-a110-1da253b34772/images/ec6024140aa494ec2ccff4be47a294e52cc53d8620c652c22a6060c5932fcbd1.png",
    color: '#10B981',
    narration: "Le change debout offre de nombreux avantages : autonomie, coopération et moins de conflits. Mais il n'est pas adapté aux selles importantes. Ne jamais laisser l'enfant seul."
  },
  {
    id: 56,
    type: 'change_transmissions',
    title: "Transmissions et vigilance",
    subtitle: "Professionnalisme et traçabilité",
    transmissions: {
      title: "Après le change :",
      items: ["Noter selles/urines si nécessaire", "Signaler rougeurs ou irritations", "Transmettre tout inconfort", "Tracer les anomalies observées"]
    },
    vigilance: {
      title: "Points de vigilance :",
      items: ["Ne JAMAIS quitter l'enfant des yeux", "Respecter le protocole d'hygiène", "Adapter les gestes à l'état de l'enfant", "Respecter la pudeur"]
    },
    rappel: "Transmission factuelle, précise et sans jugement.",
    color: '#34495E',
    narration: "Après le change, notez les informations pertinentes et transmettez toute anomalie. N'oubliez jamais : ne quittez pas l'enfant des yeux, respectez l'hygiène, adaptez vos gestes et respectez la pudeur."
  },

  // Quiz Change Debout
  {
    id: 57,
    type: 'quiz',
    title: "Quiz - Le Change Debout",
    subtitle: "Testez vos connaissances",
    quizType: 'change_debout',
    color: '#10B981',
    narration: "C'est l'heure du quiz ! Testez vos connaissances sur le change debout."
  },

  // PARTIE 6: LE LAVAGE DES MAINS
  {
    id: 58,
    type: 'section',
    title: "Le Lavage des Mains",
    subtitle: "Geste essentiel de prévention des infections",
    icon: Droplets,
    image: IMAGES.lavageMains,
    objectives: [
      "Prévenir les infections en EAJE",
      "Favoriser l'autonomie de l'enfant",
      "Créer un rituel d'hygiène",
      "Développer la coordination motrice"
    ],
    color: '#0EA5E9',
    narration: "Le lavage des mains est le geste essentiel de prévention des infections en collectivité. C'est aussi un moment d'apprentissage pour développer l'autonomie de l'enfant."
  },
  {
    id: 59,
    type: 'lavage_mains_carousel',
    title: "Les 5 étapes du lavage des mains",
    subtitle: "Technique professionnelle avec comptine",
    color: '#0EA5E9',
    narration: "Voici les 5 étapes du lavage des mains : mouiller, savonner 30 secondes, frotter 30 secondes, rincer et sécher. Utilisez une comptine pour aider les enfants à compter le temps."
  },
  {
    id: 60,
    type: 'lavage_mains_theory',
    title: "Enrichissement théorique",
    subtitle: "Prévention et développement",
    sections: [
      {
        title: "Prévention des infections en EAJE",
        icon: Shield,
        content: "Le lavage des mains est essentiel pour prévenir les gastro-entérites, bronchiolites, et conjonctivites. Il doit être effectué avant et après les repas, après les toilettes, après un change, après s'être mouché, et après une activité extérieure."
      },
      {
        title: "Lien avec l'autonomie",
        icon: Baby,
        content: "Le lavage des mains favorise la coordination motrice, développe la conscience corporelle, responsabilise l'enfant et renforce l'estime de soi. L'adulte fait avec et non à la place."
      },
      {
        title: "Dimension relationnelle",
        icon: Heart,
        content: "Encourager sans pression, valoriser les efforts, installer un rituel quotidien et donner du sens ('on enlève les microbes')."
      }
    ],
    color: '#0EA5E9',
    narration: "Le lavage des mains prévient de nombreuses infections. Il développe aussi l'autonomie et la coordination de l'enfant. N'oubliez pas : encourager, valoriser et donner du sens à ce geste."
  },
  {
    id: 61,
    type: 'comptine',
    title: "Comptine du lavage des mains",
    subtitle: "À chanter pendant le savonnage (~30 secondes)",
    paroles: [
      "Je me lave les mains, les mains,",
      "Je frotte bien, je frotte bien,",
      "Dessus, dessous, entre les doigts,",
      "Le savon fait des bulles pour moi !",
      "",
      "Les pouces aussi, les pouces aussi,",
      "Et les ongles, petit bout d'oui !",
      "Je rince à l'eau, je sèche bien,",
      "Mes mains sont propres, je suis malin !"
    ],
    image: IMAGES.lavageMains,
    color: '#A855F7',
    narration: "Voici une comptine pour accompagner le lavage des mains. Je me lave les mains, les mains, je frotte bien, je frotte bien, dessus, dessous, entre les doigts, le savon fait des bulles pour moi !"
  },

  // Quiz Lavage des mains
  {
    id: 62,
    type: 'quiz',
    title: "Quiz - Le Lavage des Mains",
    subtitle: "Testez vos connaissances",
    quizType: 'lavage_mains',
    color: '#0EA5E9',
    narration: "C'est l'heure du quiz ! Testez vos connaissances sur le lavage des mains."
  },

  // PARTIE 7: LE BAIN DU NOURRISSON
  {
    id: 63,
    type: 'section',
    title: "Le Bain du Nourrisson",
    subtitle: "Un moment de bien-être et d'hygiène",
    icon: Droplets,
    image: IMAGES.babyHygiene,
    objectives: [
      "Assurer l'hygiène corporelle de l'enfant",
      "Créer un moment de détente et de plaisir",
      "Observer l'état cutané",
      "Favoriser le développement sensoriel"
    ],
    color: '#0891B2',
    narration: "Le bain du nourrisson est un soin d'hygiène essentiel mais aussi un moment privilégié de relation et de bien-être pour l'enfant."
  },
  {
    id: 64,
    type: 'bain_carousel',
    title: "Les 10 étapes du bain",
    subtitle: "Technique professionnelle - Diaporama interactif",
    color: '#0891B2',
    narration: "Voici les 10 étapes du bain du nourrisson. Lavage des mains, préparation de l'eau à 37 degrés, déshabillage, mise à l'eau, lavage du corps, lavage des cheveux, rinçage, sortie du bain, séchage et habillage."
  },

  // Quiz Bain
  {
    id: 65,
    type: 'quiz',
    title: "Quiz - Le Bain du Nourrisson",
    subtitle: "Testez vos connaissances sur le bain",
    quizType: 'bain',
    color: '#0891B2',
    narration: "C'est l'heure du quiz ! Testez vos connaissances sur le bain du nourrisson."
  },

  // PARTIE 8: SOINS DU CORDON OMBILICAL
  {
    id: 66,
    type: 'section',
    title: "Soins du Cordon Ombilical",
    subtitle: "Surveillance et hygiène du nouveau-né",
    icon: Shield,
    image: "https://static.prod-images.emergentagent.com/jobs/6dd9a748-1781-47e8-95b8-945bc0962496/images/6faa2d28a11a13cbd1f4585ac23e1c5be59572b360be11a8efdcecd0fee027c5.png",
    objectives: [
      "Prévenir l'infection du cordon",
      "Favoriser une cicatrisation optimale",
      "Détecter les signes d'alerte",
      "Assurer des transmissions précises"
    ],
    color: '#059669',
    narration: "Les soins du cordon ombilical sont essentiels chez le nouveau-né. Ils permettent de prévenir les infections et d'assurer une bonne cicatrisation jusqu'à la chute du cordon."
  },
  {
    id: 67,
    type: 'cordon_carousel',
    title: "Les 7 étapes des soins du cordon",
    subtitle: "Technique professionnelle - Diaporama interactif",
    color: '#059669',
    narration: "Voici les 7 étapes des soins du cordon ombilical. Lavage des mains, préparation du matériel, nettoyage de la base, nettoyage sous le cordon, observation, pliage de la couche et transmissions."
  },

  // Quiz Cordon
  {
    id: 68,
    type: 'quiz',
    title: "Quiz - Soins du Cordon",
    subtitle: "Testez vos connaissances sur les soins du cordon",
    quizType: 'cordon',
    color: '#059669',
    narration: "C'est l'heure du quiz ! Testez vos connaissances sur les soins du cordon ombilical."
  },

  // PARTIE 9: AUTONOMIE
  {
    id: 69,
    type: 'section',
    title: "L'Autonomie",
    subtitle: "Développer la confiance et l'estime de soi",
    icon: Baby,
    image: IMAGES.toddlerPlay,
    objectives: [
      "Développer la confiance en soi",
      "Favoriser l'estime de soi (besoin de Maslow)",
      "Permettre les apprentissages par l'expérience",
      "Renforcer la motricité fine et globale"
    ],
    color: '#F39C12',
    narration: "L'autonomie est essentielle au développement de l'enfant."
  },
  {
    id: 70,
    type: 'content',
    title: "Favoriser l'autonomie selon l'âge",
    image: IMAGES.toddlerPlay,
    sections: [
      { title: "Chez le bébé", items: ["Laisser explorer au sol en sécurité", "Proposer des objets adaptés"] },
      { title: "Chez le moyen", items: ["Se laver les mains avec aide", "Ranger ses jouets", "Manger seul partiellement"] },
      { title: "Chez le grand", items: ["S'habiller avec aide partielle", "Participer aux règles de vie", "Exprimer ses choix"] }
    ],
    highlight: "Principe fondamental : \"Faire avec\" et non \"à la place de\" l'enfant.",
    color: '#F39C12',
    narration: "On favorise l'autonomie à chaque âge. Le principe est de faire avec l'enfant, pas à sa place."
  },

  // Quiz Autonomie
  {
    id: 71,
    type: 'quiz',
    title: "Quiz - L'Autonomie",
    subtitle: "Testez vos connaissances sur l'autonomie",
    quizType: 'autonomie',
    color: '#F39C12',
    narration: "C'est l'heure du quiz ! Testez vos connaissances sur l'autonomie de l'enfant."
  },

  // PARTIE 10: SÉCURITÉ AFFECTIVE
  {
    id: 72,
    type: 'section',
    title: "La Sécurité Affective",
    subtitle: "Base du développement harmonieux",
    icon: Heart,
    image: IMAGES.motherBonding,
    objectives: [
      "Créer un environnement sécurisant",
      "Répondre aux besoins d'attachement",
      "Favoriser l'exploration en confiance",
      "Accompagner les émotions"
    ],
    color: '#E91E63',
    narration: "La sécurité affective est la base du développement harmonieux de l'enfant."
  },
  {
    id: 73,
    type: 'content',
    title: "Construire la sécurité affective",
    image: IMAGES.motherBonding,
    sections: [
      { title: "Attitudes de l'AP", items: ["Être disponible et à l'écoute", "Répondre avec constance", "Verbaliser les émotions"] },
      { title: "Dans les soins", items: ["Prévenir de chaque geste", "Respecter le rythme", "Maintenir le contact visuel"] },
      { title: "Au quotidien", items: ["Rituels rassurants", "Objets transitionnels", "Continuité des repères"] }
    ],
    highlight: "L'enfant sécurisé peut explorer le monde en confiance.",
    color: '#E91E63',
    narration: "L'auxiliaire de puériculture construit la sécurité affective par sa disponibilité, sa constance et son respect du rythme de l'enfant."
  },

  // Quiz Sécurité Affective
  {
    id: 74,
    type: 'quiz',
    title: "Quiz - La Sécurité Affective",
    subtitle: "Testez vos connaissances sur la sécurité affective",
    quizType: 'securite_affective',
    color: '#E91E63',
    narration: "C'est l'heure du quiz ! Testez vos connaissances sur la sécurité affective."
  },

  // PARTIE 11: SYNTHÈSE ET CONCLUSION
  {
    id: 75,
    type: 'synthesis',
    title: "Synthèse",
    subtitle: "Les points essentiels à retenir",
    points: [
      { icon: Heart, text: "L'enfant au centre de toutes nos actions", color: "#E91E63" },
      { icon: Shield, text: "Hygiène et sécurité en priorité", color: "#10B981" },
      { icon: Baby, text: "Favoriser l'autonomie progressivement", color: "#F39C12" },
      { icon: Users, text: "Communication et transmissions professionnelles", color: "#3498DB" }
    ],
    color: '#27AE60',
    narration: "En synthèse, retenez ces points essentiels : l'enfant au centre de nos actions, l'hygiène et la sécurité en priorité, favoriser l'autonomie progressivement et assurer des transmissions professionnelles."
  },
  {
    id: 76,
    type: 'conclusion',
    title: "Félicitations !",
    subtitle: "Vous avez terminé cette formation",
    message: "Vous maîtrisez maintenant les accompagnements quotidiens de l'enfant selon le référentiel DEAP.",
    nextSteps: [
      "Pratiquez les gestes techniques",
      "Révisez les besoins de Virginia Henderson",
      "Préparez votre dossier VAE"
    ],
    color: '#E75480',
    narration: "Félicitations ! Vous avez terminé cette formation sur les accompagnements quotidiens. Continuez à pratiquer et à réviser pour votre VAE. Bonne réussite !"
  },

  // QUIZ GÉNÉRAL - 20 questions
  {
    id: 77,
    type: 'quiz',
    title: "Quiz Général - Évaluation Finale",
    subtitle: "20 questions pour valider vos acquis",
    quizType: 'general',
    color: '#E75480',
    narration: "Bienvenue au quiz général ! 20 questions pour évaluer vos connaissances sur l'ensemble de la formation. Bonne chance !"
  }
];

const DEAPActivite1Presentation = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const audioRef = useRef(null);

  const slide = SLIDES[currentSlide];

  const handlePrev = () => {
    stopAudio();
    setCurrentSlide((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    stopAudio();
    setCurrentSlide((prev) => Math.min(SLIDES.length - 1, prev + 1));
  };

  const handleSlideChange = (index) => {
    if (index !== currentSlide) {
      stopAudio();
    }
  };

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setIsPlaying(false);
  };

  const handlePlayNarration = async () => {
    if (isPlaying) {
      stopAudio();
      return;
    }

    if (!slide.narration) return;

    setIsLoading(true);
    try {
      const response = await axios.post(`${BACKEND_URL}/api/tts/generate`, {
        text: slide.narration,
        voice: "nova",
        speed: 1.0
      });

      if (response.data.audio_base64) {
        const audioSrc = `data:audio/mp3;base64,${response.data.audio_base64}`;
        
        if (audioRef.current) {
          audioRef.current.src = audioSrc;
          audioRef.current.play();
          setIsPlaying(true);
        }
      }
    } catch (error) {
      console.error('Error generating audio:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderSlideContent = () => {
    const Icon = slide.icon;

    // Function to navigate to a specific slide
    const goToSlide = (slideIndex) => {
      setCurrentSlide(slideIndex - 1); // Convert 1-based to 0-based index
    };

    switch (slide.type) {
      case 'table_of_contents':
        return (
          <div style={{ padding: '1rem' }}>
            <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
              <h1 style={{ fontSize: '2rem', color: slide.color, marginBottom: '0.5rem' }}>{slide.title}</h1>
              <p style={{ color: '#666', fontSize: '1rem' }}>{slide.subtitle}</p>
            </div>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(3, 1fr)', 
              gap: '1rem',
              maxWidth: '1000px',
              margin: '0 auto'
            }}>
              {slide.sections.map((section, idx) => (
                <div 
                  key={idx}
                  onClick={() => goToSlide(section.targetSlide)}
                  style={{
                    background: `linear-gradient(135deg, ${section.color}15, ${section.color}05)`,
                    border: `2px solid ${section.color}30`,
                    borderRadius: '12px',
                    padding: '1rem',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = `0 8px 25px ${section.color}30`;
                    e.currentTarget.style.borderColor = section.color;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.borderColor = `${section.color}30`;
                  }}
                  data-testid={`toc-section-${idx}`}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                    <div style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '8px',
                      background: section.color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '0.9rem',
                      fontWeight: 'bold'
                    }}>
                      {idx + 1}
                    </div>
                    <span style={{ fontSize: '0.75rem', color: '#999' }}>Slides {section.slides}</span>
                  </div>
                  <h3 style={{ 
                    fontSize: '0.95rem', 
                    fontWeight: '600', 
                    color: section.color,
                    marginBottom: '0.5rem'
                  }}>
                    {section.title}
                  </h3>
                  {section.subsections && (
                    <div style={{ marginTop: '0.5rem', paddingLeft: '0.5rem', borderLeft: `2px solid ${section.color}30` }}>
                      {section.subsections.map((sub, subIdx) => (
                        <div 
                          key={subIdx}
                          onClick={(e) => {
                            e.stopPropagation();
                            goToSlide(sub.targetSlide);
                          }}
                          style={{
                            fontSize: '0.8rem',
                            color: '#666',
                            padding: '0.25rem 0.5rem',
                            cursor: 'pointer',
                            borderRadius: '4px',
                            transition: 'all 0.2s',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = `${section.color}20`;
                            e.currentTarget.style.color = section.color;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent';
                            e.currentTarget.style.color = '#666';
                          }}
                        >
                          → {sub.title}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        );

      case 'title':
        return (
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            {Icon && (
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: `linear-gradient(135deg, ${slide.color}, ${slide.color}88)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem'
              }}>
                <Icon size={40} style={{ color: 'white' }} />
              </div>
            )}
            <h1 style={{ fontSize: '2.5rem', color: slide.color, marginBottom: '1rem' }}>{slide.title}</h1>
            <h2 style={{ fontSize: '1.5rem', color: '#666', marginBottom: '1rem', fontWeight: 400 }}>{slide.subtitle}</h2>
            <p style={{ fontSize: '1rem', color: '#888' }}>{slide.description}</p>
          </div>
        );

      case 'theory':
        return (
          <div style={{ display: 'grid', gridTemplateColumns: slide.image ? '300px 1fr' : '1fr', gap: '2rem', alignItems: 'start' }}>
            {slide.image && (
              <img 
                src={slide.image} 
                alt={slide.title}
                style={{ width: '100%', borderRadius: '1rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}
              />
            )}
            <div>
              <h2 style={{ color: slide.color, marginBottom: '0.5rem' }}>{slide.title}</h2>
              {slide.subtitle && <p style={{ color: '#666', marginBottom: '1.5rem', fontStyle: 'italic' }}>{slide.subtitle}</p>}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {slide.content.map((item, index) => (
                  <p key={index} style={{ 
                    margin: 0, 
                    color: item.startsWith('•') ? '#555' : '#333',
                    fontWeight: item.includes(':') && !item.startsWith('•') ? 600 : 400,
                    paddingLeft: item.startsWith('•') ? '1rem' : 0
                  }}>{item}</p>
                ))}
              </div>
              {slide.highlight && (
                <div style={{ marginTop: '1.5rem', padding: '1rem', background: `${slide.color}15`, borderRadius: '0.75rem' }}>
                  <p style={{ margin: 0, color: slide.color, fontWeight: 500 }}>{slide.highlight}</p>
                </div>
              )}
            </div>
          </div>
        );

      case 'train_sommeil':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <img 
                src={slide.trainImage} 
                alt="Train du sommeil"
                style={{ 
                  maxWidth: '100%', 
                  maxHeight: '400px',
                  borderRadius: '1rem', 
                  boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
                }}
              />
            </div>
          </div>
        );

      case 'prevention_min':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1rem', textAlign: 'center' }}>{slide.subtitle}</p>
            
            <div style={{ 
              background: '#FEE2E2', 
              padding: '0.75rem 1rem', 
              borderRadius: '0.5rem', 
              marginBottom: '1rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              justifyContent: 'center'
            }}>
              <AlertTriangle size={20} style={{ color: '#DC2626' }} />
              <span style={{ color: '#DC2626', fontWeight: 600 }}>{slide.alertTitle}</span>
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.75rem' }}>
              {slide.mesures.map((mesure, index) => (
                <div key={index} style={{
                  padding: '0.75rem',
                  background: mesure.danger ? '#FEF2F2' : '#F0FDF4',
                  borderRadius: '0.75rem',
                  border: `1px solid ${mesure.danger ? '#FECACA' : '#BBF7D0'}`
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                    <span style={{ fontSize: '1.25rem' }}>{mesure.icon}</span>
                    <h4 style={{ margin: 0, color: mesure.danger ? '#DC2626' : '#16A34A', fontSize: '0.9rem' }}>{mesure.title}</h4>
                  </div>
                  <p style={{ margin: 0, color: '#555', fontSize: '0.8rem' }}>{mesure.desc}</p>
                </div>
              ))}
            </div>
            
            <div style={{ 
              marginTop: '1rem', 
              padding: '0.75rem', 
              background: '#7F1D1D', 
              borderRadius: '0.5rem',
              textAlign: 'center'
            }}>
              <p style={{ margin: 0, color: 'white', fontWeight: 600, fontSize: '0.85rem' }}>{slide.warning}</p>
            </div>
          </div>
        );

      case 'surveillance_dortoir':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem' }}>
              {slide.sections.map((section, index) => (
                <div key={index} style={{
                  padding: '1rem',
                  background: index === 0 ? '#EBF5FB' : index === 1 ? '#FEF9E7' : '#E8F8F5',
                  borderRadius: '0.75rem',
                  border: `1px solid ${index === 0 ? '#AED6F1' : index === 1 ? '#F9E79F' : '#A3E4D7'}`
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem' }}>
                    <span style={{ fontSize: '1.5rem' }}>{section.icon}</span>
                    <h4 style={{ margin: 0, color: slide.color, fontSize: '0.95rem' }}>{section.title}</h4>
                  </div>
                  <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
                    {section.items.map((item, idx) => (
                      <li key={idx} style={{ color: '#555', fontSize: '0.8rem', marginBottom: '0.4rem' }}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        );

      case 'securite_sommeil':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1rem', textAlign: 'center', fontStyle: 'italic' }}>{slide.subtitle}</p>
            
            <div style={{ 
              background: `${slide.color}10`, 
              padding: '1rem', 
              borderRadius: '0.75rem', 
              marginBottom: '1rem',
              borderLeft: `4px solid ${slide.color}`
            }}>
              <p style={{ margin: 0, color: '#333', fontSize: '0.95rem' }}>{slide.intro}</p>
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.75rem' }}>
              {slide.actions.map((action, index) => (
                <div key={index} style={{
                  padding: '0.75rem',
                  background: 'white',
                  borderRadius: '0.75rem',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                  border: `1px solid ${slide.color}30`
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                    <span style={{ fontSize: '1.25rem' }}>{action.icon}</span>
                    <h4 style={{ margin: 0, color: slide.color, fontSize: '0.9rem' }}>{action.title}</h4>
                  </div>
                  <p style={{ margin: 0, color: '#666', fontSize: '0.8rem' }}>{action.desc}</p>
                </div>
              ))}
            </div>
            
            <div style={{ 
              marginTop: '1rem', 
              padding: '0.75rem', 
              background: `linear-gradient(135deg, ${slide.color}, ${slide.color}CC)`, 
              borderRadius: '0.5rem',
              textAlign: 'center'
            }}>
              <p style={{ margin: 0, color: 'white', fontWeight: 600, fontSize: '0.95rem' }}>👉 {slide.conclusion}</p>
            </div>
          </div>
        );

      case 'change_cadre':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
              <div style={{ padding: '1rem', background: '#EBF5FB', borderRadius: '0.75rem', border: '1px solid #AED6F1' }}>
                <h4 style={{ color: '#2980B9', marginBottom: '0.75rem' }}>{slide.henderson.title}</h4>
                <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
                  {slide.henderson.items.map((item, idx) => (
                    <li key={idx} style={{ color: '#333', marginBottom: '0.35rem' }}>{item}</li>
                  ))}
                </ul>
              </div>
              <div style={{ padding: '1rem', background: '#FEF9E7', borderRadius: '0.75rem', border: '1px solid #F9E79F' }}>
                <h4 style={{ color: '#D68910', marginBottom: '0.75rem' }}>{slide.maslow.title}</h4>
                {slide.maslow.items.map((item, idx) => (
                  <div key={idx} style={{ marginBottom: '0.5rem' }}>
                    <span style={{ fontWeight: 600, color: '#B7950B' }}>{item.niveau}</span>
                    <span style={{ color: '#666' }}> : {item.desc}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ padding: '0.75rem', background: '#D5F5E3', borderRadius: '0.5rem', textAlign: 'center' }}>
              <p style={{ margin: 0, color: '#1E8449', fontWeight: 600 }}>👉 {slide.conclusion}</p>
            </div>
          </div>
        );

      case 'change_objectifs':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', justifyContent: 'center' }}>
              {slide.objectifs.map((obj, idx) => (
                <div key={idx} style={{ 
                  padding: '1rem', 
                  background: `${obj.color}15`, 
                  borderRadius: '0.75rem',
                  border: `2px solid ${obj.color}`,
                  textAlign: 'center',
                  minWidth: '150px',
                  flex: '1 1 150px',
                  maxWidth: '200px'
                }}>
                  <span style={{ fontSize: '2rem' }}>{obj.icon}</span>
                  <p style={{ margin: '0.5rem 0 0', color: obj.color, fontWeight: 600, fontSize: '0.85rem' }}>{obj.title}</p>
                </div>
              ))}
            </div>
          </div>
        );

      case 'change_preparation':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div style={{ padding: '1rem', background: '#EBF5FB', borderRadius: '0.75rem' }}>
                <h4 style={{ color: '#2980B9', marginBottom: '0.75rem' }}>🧴 {slide.materiel.title}</h4>
                <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
                  {slide.materiel.items.map((item, idx) => (
                    <li key={idx} style={{ color: '#333', marginBottom: '0.35rem', fontSize: '0.9rem' }}>{item}</li>
                  ))}
                </ul>
              </div>
              <div style={{ padding: '1rem', background: '#FDEDEC', borderRadius: '0.75rem' }}>
                <h4 style={{ color: '#C0392B', marginBottom: '0.75rem' }}>👩‍⚕️ {slide.organisation.title}</h4>
                <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
                  {slide.organisation.items.map((item, idx) => (
                    <li key={idx} style={{ color: '#333', marginBottom: '0.35rem', fontSize: '0.9rem' }}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        );

      case 'change_technique':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ background: '#FDEDEC', padding: '0.75rem', borderRadius: '0.5rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <AlertTriangle size={20} style={{ color: '#C0392B', flexShrink: 0 }} />
              <p style={{ margin: 0, color: '#922B21', fontSize: '0.85rem' }}>{slide.alerte}</p>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem', marginBottom: '1rem' }}>
              {slide.etapes.map((etape) => (
                <div key={etape.num} style={{ padding: '0.5rem', background: `${slide.color}15`, borderRadius: '0.5rem', textAlign: 'center' }}>
                  <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: slide.color, color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 0.35rem', fontWeight: 700, fontSize: '0.85rem' }}>{etape.num}</div>
                  <p style={{ margin: 0, fontSize: '0.75rem', color: '#333' }}>{etape.text}</p>
                </div>
              ))}
            </div>
            <div style={{ padding: '0.5rem', background: '#D5F5E3', borderRadius: '0.5rem', textAlign: 'center' }}>
              <p style={{ margin: 0, color: '#1E8449', fontWeight: 600, fontSize: '0.9rem' }}>👉 {slide.principe}</p>
            </div>
          </div>
        );

      case 'change_age':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem' }}>
              {slide.tranches.map((tranche, idx) => (
                <div key={idx} style={{ padding: '1rem', background: idx === 0 ? '#FCF3CF' : idx === 1 ? '#D5F5E3' : '#EBF5FB', borderRadius: '0.75rem' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem' }}>
                    <span style={{ fontSize: '1.5rem' }}>{tranche.icon}</span>
                    <h4 style={{ margin: 0, color: slide.color, fontSize: '0.95rem' }}>{tranche.age}</h4>
                  </div>
                  <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
                    {tranche.actions.map((action, i) => (
                      <li key={i} style={{ color: '#333', fontSize: '0.8rem', marginBottom: '0.35rem' }}>{action}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        );

      case 'change_observation':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '0.5rem', marginBottom: '1rem' }}>
              {slide.observations.map((obs, idx) => (
                <div key={idx} style={{ padding: '0.75rem', background: '#FEF9E7', borderRadius: '0.5rem', textAlign: 'center' }}>
                  <h5 style={{ margin: '0 0 0.35rem', color: '#B7950B', fontSize: '0.85rem' }}>{obs.element}</h5>
                  <p style={{ margin: 0, color: '#666', fontSize: '0.75rem' }}>{obs.detail}</p>
                </div>
              ))}
            </div>
            <div style={{ padding: '0.75rem', background: '#FDEDEC', borderRadius: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
              <AlertTriangle size={20} style={{ color: '#C0392B' }} />
              <p style={{ margin: 0, color: '#922B21', fontWeight: 600 }}>{slide.alerte}</p>
            </div>
          </div>
        );

      case 'change_prevention':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'center' }}>
              {slide.mesures.map((mesure, idx) => (
                <div key={idx} style={{ 
                  padding: '1rem 1.5rem', 
                  background: '#D5F5E3', 
                  borderRadius: '2rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}>
                  <span style={{ fontSize: '1.25rem' }}>{mesure.icon}</span>
                  <span style={{ color: '#1E8449', fontWeight: 500 }}>{mesure.text}</span>
                </div>
              ))}
            </div>
          </div>
        );

      case 'change_relationnel':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div style={{ padding: '1rem', background: '#FCE4EC', borderRadius: '0.75rem' }}>
                <h4 style={{ color: slide.color, marginBottom: '0.75rem' }}>Le change est :</h4>
                <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
                  {slide.dimensions.map((dim, idx) => (
                    <li key={idx} style={{ color: '#333', marginBottom: '0.35rem' }}>{dim}</li>
                  ))}
                </ul>
              </div>
              <div style={{ padding: '1rem', background: '#F3E5F5', borderRadius: '0.75rem' }}>
                <h4 style={{ color: '#7B1FA2', marginBottom: '0.75rem' }}>Attitudes professionnelles :</h4>
                {slide.attitudes.map((att, idx) => (
                  <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.35rem' }}>
                    <span>{att.icon}</span>
                    <span style={{ color: '#333', fontSize: '0.9rem' }}>{att.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      case 'change_autonomie':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'center', marginBottom: '1rem' }}>
              {slide.actions.map((action, idx) => (
                <div key={idx} style={{ 
                  padding: '1rem 1.5rem', 
                  background: `${slide.color}15`, 
                  borderRadius: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  border: `2px solid ${slide.color}40`
                }}>
                  <span style={{ fontSize: '1.5rem' }}>{action.icon}</span>
                  <span style={{ color: '#333', fontWeight: 500 }}>{action.text}</span>
                </div>
              ))}
            </div>
            <div style={{ padding: '0.75rem', background: `linear-gradient(135deg, ${slide.color}, ${slide.color}CC)`, borderRadius: '0.5rem', textAlign: 'center' }}>
              <p style={{ margin: 0, color: 'white', fontWeight: 600 }}>🎯 {slide.conclusion}</p>
            </div>
          </div>
        );

      case 'change_transmissions':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
              <div style={{ padding: '1rem', background: '#EBF5FB', borderRadius: '0.75rem' }}>
                <h4 style={{ color: '#2980B9', marginBottom: '0.75rem' }}>📋 {slide.transmissions.title}</h4>
                <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
                  {slide.transmissions.items.map((item, idx) => (
                    <li key={idx} style={{ color: '#333', marginBottom: '0.35rem', fontSize: '0.9rem' }}>{item}</li>
                  ))}
                </ul>
              </div>
              <div style={{ padding: '1rem', background: '#FDEDEC', borderRadius: '0.75rem' }}>
                <h4 style={{ color: '#C0392B', marginBottom: '0.75rem' }}>⚠️ {slide.vigilance.title}</h4>
                <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
                  {slide.vigilance.items.map((item, idx) => (
                    <li key={idx} style={{ color: '#333', marginBottom: '0.35rem', fontSize: '0.9rem' }}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div style={{ padding: '0.5rem', background: '#34495E', borderRadius: '0.5rem', textAlign: 'center' }}>
              <p style={{ margin: 0, color: 'white', fontSize: '0.9rem' }}>{slide.rappel}</p>
            </div>
          </div>
        );

      case 'section':
        return (
          <div style={{ textAlign: 'center' }}>
            {Icon && (
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: `linear-gradient(135deg, ${slide.color}, ${slide.color}88)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem'
              }}>
                <Icon size={40} style={{ color: 'white' }} />
              </div>
            )}
            <h2 style={{ color: slide.color, marginBottom: '0.5rem' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '2rem' }}>{slide.subtitle}</p>
            
            <div style={{ display: 'grid', gridTemplateColumns: slide.image ? '300px 1fr' : '1fr', gap: '2rem', textAlign: 'left' }}>
              {slide.image && (
                <img 
                  src={slide.image} 
                  alt={slide.title}
                  style={{ width: '100%', borderRadius: '1rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}
                />
              )}
              <div>
                <h4 style={{ color: '#333', marginBottom: '1rem' }}>Objectifs :</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  {slide.objectives.map((obj, index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                      <div style={{
                        width: '28px',
                        height: '28px',
                        borderRadius: '50%',
                        background: slide.color,
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.85rem',
                        fontWeight: 600,
                        flexShrink: 0
                      }}>{index + 1}</div>
                      <span style={{ color: slide.color }}>{obj}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );

      case 'content':
        return (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
              {slide.icon && (
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  background: `${slide.color}20`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <slide.icon size={25} style={{ color: slide.color }} />
                </div>
              )}
              <div>
                <h2 style={{ color: slide.color, margin: 0 }}>{slide.title}</h2>
                {slide.subtitle && <p style={{ color: '#666', margin: 0 }}>{slide.subtitle}</p>}
              </div>
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: slide.image ? '250px 1fr' : '1fr', gap: '2rem' }}>
              {slide.image && (
                <img 
                  src={slide.image} 
                  alt={slide.title}
                  style={{ width: '100%', borderRadius: '1rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', objectFit: 'cover', maxHeight: '300px' }}
                />
              )}
              <div>
                {slide.items && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {slide.items.map((item, index) => (
                      <div key={index} style={{ padding: '1rem', background: `${slide.color}08`, borderRadius: '0.75rem', borderLeft: `4px solid ${slide.color}` }}>
                        <h4 style={{ margin: '0 0 0.25rem 0', color: slide.color }}>{item.title}</h4>
                        <p style={{ margin: 0, color: '#666', fontSize: '0.9rem' }}>{item.desc}</p>
                      </div>
                    ))}
                  </div>
                )}
                {slide.actions && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {slide.actions.map((action, index) => (
                      <div key={index} style={{ padding: '1rem', background: `${slide.color}08`, borderRadius: '0.75rem', borderLeft: `4px solid ${slide.color}` }}>
                        <h4 style={{ margin: '0 0 0.25rem 0', color: slide.color }}>{action.title}</h4>
                        <p style={{ margin: 0, color: '#666', fontSize: '0.9rem' }}>{action.desc}</p>
                      </div>
                    ))}
                  </div>
                )}
                {slide.sections && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    {slide.sections.map((section, index) => (
                      <div key={index}>
                        <h4 style={{ color: slide.color, marginBottom: '0.5rem' }}>{section.title}</h4>
                        <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
                          {section.items.map((item, i) => (
                            <li key={i} style={{ marginBottom: '0.25rem', color: '#555' }}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
                {slide.categories && (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                    {slide.categories.map((cat, index) => (
                      <div key={index} style={{ padding: '1rem', background: `${slide.color}08`, borderRadius: '0.75rem' }}>
                        <h4 style={{ margin: '0 0 0.5rem 0', color: slide.color, fontSize: '0.9rem' }}>{cat.title}</h4>
                        <ul style={{ margin: 0, paddingLeft: '1rem', fontSize: '0.85rem' }}>
                          {cat.items.map((item, i) => (
                            <li key={i} style={{ marginBottom: '0.25rem', color: '#555' }}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            
            {slide.highlight && (
              <div style={{ marginTop: '1.5rem', padding: '1rem', background: `${slide.color}15`, borderRadius: '0.75rem', textAlign: 'center' }}>
                <p style={{ margin: 0, color: slide.color, fontWeight: 500 }}>{slide.highlight}</p>
              </div>
            )}
          </div>
        );

      case 'quantites':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1rem', textAlign: 'center' }}>{slide.subtitle}</p>
            
            <div style={{ overflowX: 'auto', marginBottom: '1rem' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
                <thead>
                  <tr style={{ background: slide.color }}>
                    <th style={{ padding: '0.5rem', color: 'white', textAlign: 'left' }}>Âge</th>
                    <th style={{ padding: '0.5rem', color: 'white', textAlign: 'center' }}>Lait</th>
                    <th style={{ padding: '0.5rem', color: 'white', textAlign: 'center' }}>Féculents</th>
                    <th style={{ padding: '0.5rem', color: 'white', textAlign: 'center' }}>Légumes</th>
                    <th style={{ padding: '0.5rem', color: 'white', textAlign: 'center' }}>Protéines</th>
                    <th style={{ padding: '0.5rem', color: 'white', textAlign: 'center' }}>Fruits</th>
                  </tr>
                </thead>
                <tbody>
                  {slide.quantitesData.map((row, index) => (
                    <tr key={index} style={{ background: index % 2 === 0 ? '#f8f9fa' : 'white' }}>
                      <td style={{ padding: '0.5rem', fontWeight: 600, color: slide.color }}>{row.age}</td>
                      <td style={{ padding: '0.5rem', textAlign: 'center', fontSize: '0.8rem' }}>{row.lait}</td>
                      <td style={{ padding: '0.5rem', textAlign: 'center', fontSize: '0.8rem' }}>{row.feculents}</td>
                      <td style={{ padding: '0.5rem', textAlign: 'center', fontSize: '0.8rem' }}>{row.legumes}</td>
                      <td style={{ padding: '0.5rem', textAlign: 'center', fontSize: '0.8rem' }}>{row.proteines}</td>
                      <td style={{ padding: '0.5rem', textAlign: 'center', fontSize: '0.8rem' }}>{row.fruits}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            <div style={{ background: `${slide.color}10`, padding: '1rem', borderRadius: '0.75rem' }}>
              <h4 style={{ color: slide.color, margin: '0 0 0.5rem 0', fontSize: '0.9rem' }}>À retenir :</h4>
              <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
                {slide.tips.map((tip, index) => (
                  <li key={index} style={{ color: '#555', marginBottom: '0.25rem', fontSize: '0.85rem' }}>{tip}</li>
                ))}
              </ul>
            </div>
          </div>
        );

      case 'highlight':
        return (
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '2rem' }}>{slide.subtitle}</p>
            
            <div style={{
              background: `linear-gradient(135deg, ${slide.color}, ${slide.color}88)`,
              color: 'white',
              padding: '2rem',
              borderRadius: '1rem',
              marginBottom: '2rem'
            }}>
              <p style={{ fontSize: '2rem', fontWeight: 700, margin: 0 }}>{slide.mainRule}</p>
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.75rem', marginBottom: '1.5rem' }}>
              {slide.explanation.map((item, index) => (
                <div key={index} style={{ padding: '0.75rem', background: '#f8f9fa', borderRadius: '0.5rem', fontSize: '0.9rem' }}>
                  {item}
                </div>
              ))}
            </div>
            
            {slide.warning && (
              <div style={{ padding: '1rem', background: '#FEE2E2', borderRadius: '0.75rem', border: '1px solid #E74C3C' }}>
                <AlertTriangle size={20} style={{ color: '#E74C3C', marginRight: '0.5rem', verticalAlign: 'middle' }} />
                <span style={{ color: '#E74C3C', fontWeight: 500 }}>{slide.warning}</span>
              </div>
            )}
          </div>
        );

      case 'table':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
                <thead>
                  <tr style={{ background: slide.color }}>
                    <th style={{ padding: '0.75rem', color: 'white', textAlign: 'left' }}>Âge</th>
                    <th style={{ padding: '0.75rem', color: 'white', textAlign: 'center' }}>Nb biberons/jour</th>
                    <th style={{ padding: '0.75rem', color: 'white', textAlign: 'center' }}>Volume</th>
                    <th style={{ padding: '0.75rem', color: 'white', textAlign: 'center' }}>Poudre</th>
                  </tr>
                </thead>
                <tbody>
                  {slide.tableData.map((row, index) => (
                    <tr key={index} style={{ background: index % 2 === 0 ? '#f8f9fa' : 'white' }}>
                      <td style={{ padding: '0.75rem', fontWeight: 500 }}>{row.age}</td>
                      <td style={{ padding: '0.75rem', textAlign: 'center' }}>{row.quantite}</td>
                      <td style={{ padding: '0.75rem', textAlign: 'center' }}>{row.volume}</td>
                      <td style={{ padding: '0.75rem', textAlign: 'center' }}>{row.poudre}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            {slide.note && (
              <div style={{ marginTop: '1rem', padding: '1rem', background: `${slide.color}10`, borderRadius: '0.5rem' }}>
                <p style={{ margin: 0, color: '#666', fontSize: '0.85rem' }}>{slide.note}</p>
              </div>
            )}
          </div>
        );

      case 'carousel':
        return (
          <div>
            <BiberonCarousel />
          </div>
        );

      case 'change_carousel':
        return (
          <div>
            <ChangeCarousel />
          </div>
        );

      case 'bain_carousel':
        return (
          <div>
            <BainCarousel />
          </div>
        );

      case 'cordon_carousel':
        return (
          <div>
            <CordonCarousel />
          </div>
        );

      case 'change_debout_carousel':
        return (
          <div>
            <ChangeDeboutCarousel />
          </div>
        );

      case 'change_debout_theorie':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
              <div style={{ background: `${slide.color}10`, padding: '1.5rem', borderRadius: '1rem', border: `2px solid ${slide.color}30` }}>
                <h3 style={{ color: slide.color, marginBottom: '1rem', fontSize: '1.1rem' }}>{slide.henderson.title}</h3>
                <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
                  {slide.henderson.items.map((item, i) => (
                    <li key={i} style={{ marginBottom: '0.5rem', color: '#555' }}>{item}</li>
                  ))}
                </ul>
              </div>
              <div style={{ background: `${slide.color}10`, padding: '1.5rem', borderRadius: '1rem', border: `2px solid ${slide.color}30` }}>
                <h3 style={{ color: slide.color, marginBottom: '1rem', fontSize: '1.1rem' }}>{slide.maslow.title}</h3>
                <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
                  {slide.maslow.items.map((item, i) => (
                    <li key={i} style={{ marginBottom: '0.5rem', color: '#555' }}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div style={{ marginTop: '1.5rem', padding: '1rem', background: slide.color, borderRadius: '0.75rem', textAlign: 'center' }}>
              <p style={{ margin: 0, color: 'white', fontWeight: '600' }}>{slide.conclusion}</p>
            </div>
          </div>
        );

      case 'change_debout_quand':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <div style={{ background: slide.color, color: 'white', padding: '1.5rem', borderRadius: '1rem', textAlign: 'center', marginBottom: '1rem' }}>
                  <span style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>{slide.age}</span>
                  <p style={{ margin: '0.5rem 0 0', opacity: 0.9 }}>En général</p>
                </div>
                <div style={{ background: '#f8f9fa', padding: '1rem', borderRadius: '0.75rem' }}>
                  <h4 style={{ color: slide.color, marginBottom: '0.75rem' }}>Conditions</h4>
                  {slide.conditions.map((cond, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                      <span style={{ fontSize: '1.2rem' }}>{cond.icon}</span>
                      <span style={{ color: '#555', fontSize: '0.9rem' }}>{cond.text}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ flex: 1 }}>
                {slide.image && (
                  <img src={slide.image} alt={slide.title} style={{ width: '100%', borderRadius: '1rem', marginBottom: '1rem' }} />
                )}
                <div style={{ background: `${slide.color}10`, padding: '1rem', borderRadius: '0.75rem' }}>
                  <h4 style={{ color: slide.color, marginBottom: '0.75rem' }}>Objectifs</h4>
                  <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
                    {slide.objectifs.map((obj, i) => (
                      <li key={i} style={{ marginBottom: '0.5rem', color: '#555', fontSize: '0.9rem' }}>{obj}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );

      case 'change_debout_avantages':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ display: 'flex', gap: '1.5rem' }}>
              <div style={{ flex: 1 }}>
                <div style={{ background: '#D1FAE5', padding: '1.5rem', borderRadius: '1rem', marginBottom: '1rem' }}>
                  <h3 style={{ color: '#059669', marginBottom: '1rem' }}>Avantages</h3>
                  {slide.avantages.map((item, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                      <span style={{ fontSize: '1.1rem' }}>{item.icon}</span>
                      <span style={{ color: '#065F46' }}>{item.text}</span>
                    </div>
                  ))}
                </div>
                <div style={{ background: '#FEF3C7', padding: '1.5rem', borderRadius: '1rem' }}>
                  <h3 style={{ color: '#D97706', marginBottom: '1rem' }}>Limites</h3>
                  {slide.limites.map((item, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                      <span style={{ fontSize: '1.1rem' }}>{item.icon}</span>
                      <span style={{ color: '#92400E' }}>{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>
              {slide.image && (
                <div style={{ flex: 1 }}>
                  <img src={slide.image} alt={slide.title} style={{ width: '100%', borderRadius: '1rem', marginBottom: '1rem' }} />
                  <div style={{ background: '#FEE2E2', padding: '1rem', borderRadius: '0.75rem', textAlign: 'center' }}>
                    <p style={{ margin: 0, color: '#DC2626', fontWeight: '500' }}>{slide.rappel}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        );

      case 'steps':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            
            <div style={{ display: 'grid', gap: '0.75rem' }}>
              {slide.steps.map((step, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', padding: '1rem', background: '#f8f9fa', borderRadius: '0.75rem' }}>
                  <div style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    background: slide.color,
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    flexShrink: 0
                  }}>
                    {step.num}
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 0.25rem 0', color: '#333' }}>{step.title}</h4>
                    <p style={{ margin: 0, color: '#666', fontSize: '0.9rem' }}>{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );

      case 'positions':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem', marginBottom: '1.5rem' }}>
              {slide.positions.map((pos, index) => (
                <div key={index} style={{ textAlign: 'center' }}>
                  <img 
                    src={pos.image} 
                    alt={pos.name}
                    style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '0.75rem', marginBottom: '0.75rem' }}
                  />
                  <h4 style={{ color: slide.color, margin: '0 0 0.5rem 0', fontSize: '0.95rem' }}>{pos.name}</h4>
                  <p style={{ margin: 0, color: '#666', fontSize: '0.8rem' }}>{pos.desc}</p>
                </div>
              ))}
            </div>
            
            <div style={{ background: `${slide.color}10`, padding: '1rem', borderRadius: '0.75rem' }}>
              <h4 style={{ color: slide.color, margin: '0 0 0.5rem 0' }}>Conseils pour l'AP :</h4>
              <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
                {slide.tips.map((tip, index) => (
                  <li key={index} style={{ color: '#555', marginBottom: '0.25rem', fontSize: '0.9rem' }}>{tip}</li>
                ))}
              </ul>
            </div>
          </div>
        );

      case 'conservation':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', marginBottom: '1.5rem' }}>
              {slide.conservationRules.map((rule, index) => {
                const RuleIcon = rule.icon;
                return (
                  <div key={index} style={{ 
                    padding: '1.5rem', 
                    background: `${rule.color}10`, 
                    borderRadius: '1rem',
                    textAlign: 'center',
                    border: `2px solid ${rule.color}`
                  }}>
                    <RuleIcon size={32} style={{ color: rule.color, marginBottom: '0.5rem' }} />
                    <h4 style={{ color: rule.color, margin: '0 0 0.5rem 0' }}>{rule.type}</h4>
                    <p style={{ margin: '0 0 0.25rem 0', color: '#666', fontSize: '0.9rem' }}>{rule.temp}</p>
                    <p style={{ margin: 0, fontWeight: 700, color: rule.color }}>{rule.duree}</p>
                  </div>
                );
              })}
            </div>
            
            <div style={{ background: '#FEF3C7', padding: '1rem', borderRadius: '0.75rem' }}>
              <h4 style={{ color: '#92400E', margin: '0 0 0.5rem 0' }}>Règles importantes :</h4>
              <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
                {slide.importantRules.map((rule, index) => (
                  <li key={index} style={{ color: '#92400E', marginBottom: '0.25rem', fontSize: '0.9rem' }}>{rule}</li>
                ))}
              </ul>
            </div>
          </div>
        );

      case 'summary':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: slide.color }}>
                  <th style={{ padding: '0.75rem', color: 'white', textAlign: 'left' }}>Besoin</th>
                  <th style={{ padding: '0.75rem', color: 'white', textAlign: 'left' }}>Action</th>
                  <th style={{ padding: '0.75rem', color: 'white', textAlign: 'left' }}>Impact</th>
                </tr>
              </thead>
              <tbody>
                {slide.table.map((row, index) => (
                  <tr key={index} style={{ background: index % 2 === 0 ? '#f8f9fa' : 'white' }}>
                    <td style={{ padding: '0.75rem', fontWeight: 500 }}>{row.besoin}</td>
                    <td style={{ padding: '0.75rem' }}>{row.action}</td>
                    <td style={{ padding: '0.75rem' }}>{row.impact}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );

      case 'synthesis':
        return (
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '2rem' }}>{slide.subtitle}</p>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', maxWidth: '700px', margin: '0 auto' }}>
              {slide.points && slide.points.map((point, index) => {
                const PointIcon = point.icon;
                return (
                  <div key={index} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                    padding: '1rem',
                    background: `${point.color}10`,
                    borderRadius: '0.75rem',
                    border: `2px solid ${point.color}30`
                  }}>
                    <div style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      background: point.color,
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <PointIcon size={20} />
                    </div>
                    <span style={{ color: '#333', textAlign: 'left', fontWeight: 500 }}>{point.text}</span>
                  </div>
                );
              })}
            </div>
          </div>
        );

      case 'conclusion':
        return (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🎉</div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1rem' }}>{slide.subtitle}</p>
            <p style={{ color: '#333', marginBottom: '2rem', maxWidth: '600px', margin: '0 auto 2rem' }}>{slide.message}</p>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', maxWidth: '500px', margin: '0 auto' }}>
              <h4 style={{ color: slide.color, marginBottom: '0.5rem' }}>Prochaines étapes :</h4>
              {slide.nextSteps && slide.nextSteps.map((step, index) => (
                <div key={index} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  padding: '1rem',
                  background: `${slide.color}08`,
                  borderRadius: '0.75rem',
                  borderLeft: `4px solid ${slide.color}`
                }}>
                  <div style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '50%',
                    background: slide.color,
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.85rem',
                    fontWeight: 600,
                    flexShrink: 0
                  }}>{index + 1}</div>
                  <span style={{ color: '#333', textAlign: 'left' }}>{step}</span>
                </div>
              ))}
            </div>
          </div>
        );

      case 'introduction_aliments':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            
            <div style={{ overflowX: 'auto', marginBottom: '1.5rem' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
                <thead>
                  <tr style={{ background: slide.color }}>
                    <th style={{ padding: '0.6rem', color: 'white', textAlign: 'left', minWidth: '90px' }}>Âge</th>
                    <th style={{ padding: '0.6rem', color: 'white', textAlign: 'left' }}>Aliments à introduire</th>
                    <th style={{ padding: '0.6rem', color: 'white', textAlign: 'left', minWidth: '180px' }}>Remarques</th>
                  </tr>
                </thead>
                <tbody>
                  {slide.introductionData.map((row, index) => (
                    <tr key={index} style={{ background: index % 2 === 0 ? '#FEF3C7' : '#FFFBEB' }}>
                      <td style={{ padding: '0.6rem', fontWeight: 600, color: slide.color, verticalAlign: 'top' }}>{row.age}</td>
                      <td style={{ padding: '0.6rem', color: '#333', verticalAlign: 'top' }}>{row.aliments}</td>
                      <td style={{ padding: '0.6rem', color: '#666', fontSize: '0.8rem', fontStyle: 'italic', verticalAlign: 'top' }}>{row.remarques}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            <div style={{ background: '#FEE2E2', padding: '1rem', borderRadius: '0.75rem', border: '1px solid #FECACA' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem' }}>
                <AlertTriangle size={20} style={{ color: '#DC2626' }} />
                <h4 style={{ color: '#DC2626', margin: 0, fontSize: '0.95rem' }}>Points de vigilance</h4>
              </div>
              <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
                {slide.alertes.map((alerte, index) => (
                  <li key={index} style={{ color: '#7F1D1D', marginBottom: '0.4rem', fontSize: '0.85rem' }}>{alerte}</li>
                ))}
              </ul>
            </div>
          </div>
        );

      case 'quiz':
        const getQuizQuestions = (type) => {
          switch(type) {
            case 'alimentation': return QUIZ_ALIMENTATION;
            case 'sommeil': return QUIZ_SOMMEIL;
            case 'change_coucher': return QUIZ_CHANGE_COUCHER;
            case 'change_debout': return QUIZ_CHANGE_DEBOUT;
            case 'lavage_mains': return QUIZ_LAVAGE_MAINS;
            case 'bain': return QUIZ_BAIN;
            case 'cordon': return QUIZ_CORDON;
            case 'autonomie': return QUIZ_AUTONOMIE;
            case 'securite_affective': return QUIZ_SECURITE_AFFECTIVE;
            case 'general': return QUIZ_GENERAL;
            default: return QUIZ_GENERAL;
          }
        };
        return (
          <div>
            <QuizComponent 
              questions={getQuizQuestions(slide.quizType)}
              title={slide.title}
              color={slide.color}
            />
          </div>
        );

      case 'lavage_mains_carousel':
        return (
          <div>
            <LavageMainsCarousel />
          </div>
        );

      case 'lavage_mains_theory':
        return (
          <div>
            <h2 style={{ color: slide.color, marginBottom: '0.5rem', textAlign: 'center' }}>{slide.title}</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{slide.subtitle}</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem' }}>
              {slide.sections.map((section, idx) => {
                const SectionIcon = section.icon;
                return (
                  <div key={idx} style={{
                    background: 'white',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                    border: `2px solid ${slide.color}20`
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1rem' }}>
                      <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '10px',
                        background: `${slide.color}15`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <SectionIcon size={20} color={slide.color} />
                      </div>
                      <h3 style={{ margin: 0, color: slide.color, fontSize: '1rem' }}>{section.title}</h3>
                    </div>
                    <p style={{ color: '#555', fontSize: '0.9rem', lineHeight: '1.6', margin: 0 }}>
                      {section.content}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        );

      case 'comptine':
        return (
          <div>
            <div style={{ display: 'flex', gap: '2rem', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <div style={{
                  background: 'linear-gradient(135deg, #FDF4FF 0%, #FAE8FF 100%)',
                  borderRadius: '20px',
                  padding: '2rem',
                  border: '3px solid #E879F9'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.5rem' }}>
                    <Music size={32} color="#A855F7" />
                    <div>
                      <h2 style={{ margin: 0, color: '#7C3AED' }}>{slide.title}</h2>
                      <p style={{ margin: 0, color: '#9333EA', fontSize: '0.9rem' }}>{slide.subtitle}</p>
                    </div>
                  </div>
                  <div style={{
                    background: 'white',
                    borderRadius: '15px',
                    padding: '1.5rem',
                    fontFamily: "'Comic Sans MS', cursive, sans-serif",
                    fontSize: '1.1rem',
                    lineHeight: '2.2',
                    color: '#4C1D95'
                  }}>
                    {slide.paroles.map((line, idx) => (
                      <div key={idx} style={{ minHeight: line ? 'auto' : '0.5rem' }}>{line}</div>
                    ))}
                  </div>
                </div>
              </div>
              {slide.image && (
                <div style={{ flex: 0.8 }}>
                  <img 
                    src={slide.image} 
                    alt="Lavage des mains" 
                    style={{ 
                      width: '100%', 
                      borderRadius: '15px', 
                      boxShadow: '0 10px 30px rgba(0,0,0,0.15)' 
                    }} 
                  />
                </div>
              )}
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
      <audio ref={audioRef} onEnded={() => setIsPlaying(false)} />
      
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #3498DB, #2980B9)',
        color: 'white',
        padding: '1rem 1.5rem',
        borderRadius: '1rem 1rem 0 0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <h3 style={{ margin: 0, fontSize: '1.1rem' }}>
          Activité 1 - Diplôme d'État d'Auxiliaire de Puériculture
        </h3>
        <span style={{ opacity: 0.9 }}>{currentSlide + 1} / {SLIDES.length}</span>
      </div>

      {/* Slide content */}
      <div style={{ padding: '2rem', minHeight: '450px', background: 'white' }}>
        {renderSlideContent()}
      </div>

      {/* Controls */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem 1.5rem',
        borderTop: '1px solid #eee',
        background: 'white',
        borderRadius: '0 0 1rem 1rem'
      }}>
        <button
          onClick={handlePrev}
          disabled={currentSlide === 0}
          data-testid="btn-prev-slide"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            border: '1px solid #ddd',
            borderRadius: '0.5rem',
            background: 'white',
            cursor: currentSlide === 0 ? 'not-allowed' : 'pointer',
            opacity: currentSlide === 0 ? 0.5 : 1
          }}
        >
          <ChevronLeft size={20} />
          Précédent
        </button>

        <button
          onClick={handlePlayNarration}
          disabled={isLoading || !slide.narration}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 2rem',
            border: 'none',
            borderRadius: '2rem',
            background: isPlaying ? '#E74C3C' : '#3498DB',
            color: 'white',
            cursor: isLoading ? 'wait' : 'pointer',
            fontWeight: 500
          }}
        >
          {isLoading ? (
            <Loader2 size={20} className="animate-spin" />
          ) : isPlaying ? (
            <VolumeX size={20} />
          ) : (
            <Volume2 size={20} />
          )}
          {isLoading ? 'Chargement...' : isPlaying ? 'Arrêter' : 'Écouter'}
        </button>

        <button
          onClick={handleNext}
          disabled={currentSlide === SLIDES.length - 1}
          data-testid="btn-next-slide"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            border: 'none',
            borderRadius: '0.5rem',
            background: '#3498DB',
            color: 'white',
            cursor: currentSlide === SLIDES.length - 1 ? 'not-allowed' : 'pointer',
            opacity: currentSlide === SLIDES.length - 1 ? 0.5 : 1
          }}
        >
          Suivant
          <ChevronRight size={20} />
        </button>
      </div>

      {/* Progress bar */}
      <div style={{ height: '4px', background: '#eee', borderRadius: '2px', marginTop: '0.5rem' }}>
        <div style={{
          height: '100%',
          background: 'linear-gradient(90deg, #3498DB, #2980B9)',
          borderRadius: '2px',
          width: `${((currentSlide + 1) / SLIDES.length) * 100}%`,
          transition: 'width 0.3s ease'
        }} />
      </div>
    </div>
  );
};

export default DEAPActivite1Presentation;
